// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.AttendeeCustomTable_dashboard__ar5py {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.AttendeeCustomTable_dashboardContain__9Ea-6 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_dashboardContain__9Ea-6,
.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_dashboard__ar5py,
.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_cont2__vnuPv {
  background-Color: #0f1824;
}

.AttendeeCustomTable_top_header__fPV4a .AttendeeCustomTable_top_header_inner__7ErW4 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.AttendeeCustomTable_cont2__vnuPv {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.AttendeeCustomTable_subLink__zGuKZ svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.AttendeeCustomTable_cst_vendr__odxfK input {
  min-height: 35px !important;
}

.AttendeeCustomTable_cst_vendr__odxfK .AttendeeCustomTable_form-control__zbaGf {
  background-color: #f5f6fa;
  border: none;
}

.AttendeeCustomTable_footer__2XRLu {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.AttendeeCustomTable_bodythemelight__Fycx\\+ {
  background-color: #fff;
  padding-top: 90px;
}

.AttendeeCustomTable_bodythemedark__aBYIU {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.AttendeeCustomTable_headerthemelight__Eyjk7 {
  background-color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM {
  background-color: #132337;
}

.AttendeeCustomTable_top_header__fPV4a {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.AttendeeCustomTable_menuthemelight__wQ\\+6e {
  background-color: #fff;
}

.AttendeeCustomTable_menuthemedark__\\+bzgb {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.AttendeeCustomTable_menulinklight__g7BfP span {
  color: #666666 !important;
}

.AttendeeCustomTable_menulinklight__g7BfP a {
  color: #CBCBCB !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover span,
.AttendeeCustomTable_menulinklight__g7BfP:hover a {
  color: #fff !important;
}

.AttendeeCustomTable_menulinkdarkSelected__tRIFG {
  background-color: #1c2e45;
  color: #3b82f6;
}

.AttendeeCustomTable_menuthemelight__wQ\\+6e .AttendeeCustomTable_menulinklightSelected__UnJpq {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ {
  color: #92afd3 !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.AttendeeCustomTable_menulinklight__g7BfP .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #CBCBCB !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #fff !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #92afd3 !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ:hover .AttendeeCustomTable_sub_arrow__h6ARI svg path {
  stroke: #fff !important;
}

.AttendeeCustomTable_menulinklight__g7BfP:hover svg path,
.AttendeeCustomTable_menulinklightSelected__UnJpq svg path {
  fill: #fff !important;
}

.AttendeeCustomTable_menulinkdark__\\+srHQ:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.AttendeeCustomTable_headinglight__2yuFe {
  color: #60677e;
}

.AttendeeCustomTable_headingdark__ghMSk {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.AttendeeCustomTable_searchboxlight__T8h28 {
  background-color: #fff;
  border: none;
}

.AttendeeCustomTable_searchboxdark__Fc-G5 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.AttendeeCustomTable_searchboxdark__Fc-G5::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.AttendeeCustomTable_tableheadlight__KxfZg {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.AttendeeCustomTable_tableheadlight__KxfZg th {
  color: #fff;
}

thead .AttendeeCustomTable_tableheadlight__KxfZg th:first-child,
thead .AttendeeCustomTable_tableheaddark__wIhca th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .AttendeeCustomTable_tableheadlight__KxfZg th:last-child,
thead .AttendeeCustomTable_tableheaddark__wIhca th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.AttendeeCustomTable_table__5S-F2.AttendeeCustomTable_table-borderless__2mPFq {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.AttendeeCustomTable_tableheaddark__wIhca {
  background-color: #132337;
  color: #fff;
}

.AttendeeCustomTable_table-borderless__2mPFq tr:nth-child(even) {
  background-color: #F9FAFB;
}

.AttendeeCustomTable_table-borderless__2mPFq .AttendeeCustomTable_left-section__oyvL0 {
  padding-top: 10px;
}

.AttendeeCustomTable_tablebodylight__pdgcp td,
.AttendeeCustomTable_tablebodydark__qAncM td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.AttendeeCustomTable_tablebodylight__pdgcp {
  background-color: #fff;
}
.AttendeeCustomTable_tablebodylight__pdgcp:hover {
  background-color: #fff;
  cursor: auto;
}

.AttendeeCustomTable_tablebodydark__qAncM {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.AttendeeCustomTable_tablebodydark__qAncM:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.AttendeeCustomTable_paginationlight__40Aii {
  color: #60677e !important;
  font-size: 13px !important;
}

.AttendeeCustomTable_paginationdark__4R6bb {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.AttendeeCustomTable_formthemelight__TKLpc {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.AttendeeCustomTable_formthemedark__lm8-U {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.AttendeeCustomTable_formthemedark__lm8-U ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.AttendeeCustomTable_viewformlight__evfnU {
  background-color: #f3f6f9;
}

.AttendeeCustomTable_permissionboxlight__hZBAe {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.AttendeeCustomTable_permissionboxdark__B9ap7 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.AttendeeCustomTable_errormsgclr__fHGm5 {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.AttendeeCustomTable_graphclrlight__f3TwN {
  background-color: #fff;
}

.AttendeeCustomTable_graphclrdark__C5z2h {
  background-color: #132337;
}

/* 
Counter theme
*/
#AttendeeCustomTable_card1bglight__9LW9u {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card1bgdark__dRgRB {
  background: #392f28;
}

#AttendeeCustomTable_card2bglight__34AQ0 {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card2bgdark__kSbyi {
  background: #1c3238;
}

#AttendeeCustomTable_card3bglight__20AQ5 {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card3bgdark__PvhS2 {
  background: #3a2434;
}

#AttendeeCustomTable_card4bglight__iBmgK {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#AttendeeCustomTable_card4bgdark__A-nK2 {
  background: #2f264f;
}

#AttendeeCustomTable_card1bgdark__dRgRB a,
#AttendeeCustomTable_card1bgdark__dRgRB p,
#AttendeeCustomTable_card2bgdark__kSbyi a,
#AttendeeCustomTable_card2bgdark__kSbyi p,
#AttendeeCustomTable_card3bgdark__PvhS2 a,
#AttendeeCustomTable_card3bgdark__PvhS2 p,
#AttendeeCustomTable_card4bgdark__A-nK2 a,
#AttendeeCustomTable_card4bgdark__A-nK2 p {
  color: #fff;
}

/* 
Action button theme
*/
.AttendeeCustomTable_actionbtnlight__oVVbZ {
  color: rgba(70, 71, 91, 0.8705882353);
}

.AttendeeCustomTable_actionbtndark__b6SuU {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.AttendeeCustomTable_profiledropdownlight__Esary {
  background-color: #fff;
}

.AttendeeCustomTable_profiledropdowndark__ZKBNt {
  background-color: #151521;
}

.AttendeeCustomTable_settingsection__Bfq\\+v #AttendeeCustomTable_addform__SXsM9.AttendeeCustomTable_formthemedark__lm8-U .AttendeeCustomTable_savebtn__6wLWt {
  background-color: #3b82f6;
  color: #fff;
}

#AttendeeCustomTable_addform__SXsM9.AttendeeCustomTable_formthemedark__lm8-U .AttendeeCustomTable_savebtn__6wLWt {
  background-color: #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_profile_conatiner__KnlOE {
  border-radius: 5px !important;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_ag-theme-alpine__ZXAFI .AttendeeCustomTable_ag-row__OHnLq {
  background: #000 !important;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_formbtn__aCSGq {
  background-color: #3b82f6;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_formbtn__aCSGq:hover {
  background-color: #2563eb;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_resetbtn__ljCy- {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.AttendeeCustomTable_headingdark__ghMSk span {
  background-color: #132337;
}

.AttendeeCustomTable_resetbtn__ljCy- {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.AttendeeCustomTable_resetbtn__ljCy-:hover,
.AttendeeCustomTable_resetbtn__ljCy-:active,
.AttendeeCustomTable_resetbtn__ljCy-:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.AttendeeCustomTable_addBtn__YJnoY {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.AttendeeCustomTable_addDltBtn__7aHOO {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.AttendeeCustomTable_addbtnlight__948dV {
  background-color: #38A169;
}

.AttendeeCustomTable_addbtndark__26l-y {
  background-color: #3b82f6;
}

.AttendeeCustomTable_addbtndark__26l-y:hover {
  background-color: #2563eb;
}

.AttendeeCustomTable_formthemedark__lm8-U label {
  color: #92afd3;
}

.AttendeeCustomTable_addBtn__YJnoY svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.AttendeeCustomTable_addBtn__YJnoY:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.AttendeeCustomTable_cust_addBtn__rVSnr.AttendeeCustomTable_addBtn__YJnoY svg {
  top: 2px;
}

.AttendeeCustomTable_deleteBtn__KsvX9 {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.AttendeeCustomTable_deleteBtn__KsvX9:active,
.AttendeeCustomTable_deleteBtn__KsvX9:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.AttendeeCustomTable_deleteBtn__KsvX9 svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.AttendeeCustomTable_deleteBtn__KsvX9:hover,
.AttendeeCustomTable_deleteBtn__KsvX9:active,
.AttendeeCustomTable_deleteBtn__KsvX9:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.AttendeeCustomTable_confirmBtn__P\\+GTu {
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  background-color: #131F43 !important;
}

.AttendeeCustomTable_confirmBtn__P\\+GTu:active,
.AttendeeCustomTable_confirmBtn__P\\+GTu:focus {
  background-color: #131F43 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.AttendeeCustomTable_confirmBtn__P\\+GTu:hover,
.AttendeeCustomTable_confirmBtn__P\\+GTu:active,
.AttendeeCustomTable_confirmBtn__P\\+GTu:focus {
  background-color: #0f1824 !important;
}

.AttendeeCustomTable_confirmBtn__P\\+GTu svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-body__Cz2Ep {
  padding: 35px;
  text-align: center;
}

.AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_delet_icon__P4-5Z {
  margin-bottom: 11px;
}

.AttendeeCustomTable_delPopContainer__xhcoA p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.AttendeeCustomTable_arrowback__jXmv0 svg {
  fill: #000;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_arrowback__jXmv0 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_arrowback__jXmv0 svg {
  fill: #3b82f6;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_drpdwn_btn__0xF-4 {
  background-color: #132337;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_empname__\\+7jN8 {
  color: #92afd3 !important;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_navitemli__TqhdC a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_tabnavli__b7GqZ a.AttendeeCustomTable_settingsgeneral__SwlNi,
.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_tabnavli__b7GqZ a.AttendeeCustomTable_settingslinks__Ag6yJ:hover {
  background-color: #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_bodythemedark__aBYIU .AttendeeCustomTable_tabnavli__b7GqZ a.AttendeeCustomTable_settingslinks__Ag6yJ {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm {
  background-color: #1c2e45;
  color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm ul li a,
.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm .AttendeeCustomTable_dropdown_item__ePkjb,
.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm .AttendeeCustomTable_dropdown_item__ePkjb h5 {
  color: #fff;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm ul li a:hover,
.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_dropdown_menu_contain__0x2Mm .AttendeeCustomTable_dropdown_item__ePkjb:hover {
  background-color: #132337;
  color: #fff;
}

.AttendeeCustomTable_dropdown_item__ePkjb:active {
  background-color: #F5F6FA;
}

.AttendeeCustomTable_profile_arrrow_dwn__X24e- {
  stroke: #132337;
}

.AttendeeCustomTable_headerthemedark__rrIXM .AttendeeCustomTable_profile_arrrow_dwn__X24e- {
  stroke: #fff;
}

.AttendeeCustomTable_dateinputbox1__H9kdw input,
.AttendeeCustomTable_dateinputbox1__H9kdw span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-content__J1sSs {
  border-radius: 10px;
  min-width: 399px;
}

.AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-dialog__lQ247 {
  max-width: 100% !important;
}

.AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-content__J1sSs {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-header__yQJ5J {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .AttendeeCustomTable_btn-primary__7phB5:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.AttendeeCustomTable_form-select__b\\+156 {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .AttendeeCustomTable_CustomTable_tableheadlight__HuHZw__INszt th:first-child,
thead .AttendeeCustomTable_CustomTable_tableheaddark__nwqb4__Ydh-G th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
}

@media only screen and (max-width: 1200px) {
  .AttendeeCustomTable_tableheadlight__KxfZg th {
    min-width: 170px;
  }
}
@media only screen and (max-width: 1024px) {
  .AttendeeCustomTable_dashboard__ar5py {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden;
  }
  .AttendeeCustomTable_cont2__vnuPv {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
  /*.tableheadlight th {
    min-width: 200px !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .AttendeeCustomTable_sectionright__VsLJr {
    float: unset !important;
  }
  .AttendeeCustomTable_formthemelight__TKLpc {
    padding: 10px 0 !important;
    box-shadow: none !important;
  }
  .AttendeeCustomTable_dashboard__ar5py {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .AttendeeCustomTable_cont2__vnuPv {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .AttendeeCustomTable_bodythemelight__Fycx\\+,
.AttendeeCustomTable_bodythemedark__aBYIU {
    padding-top: 110px;
  }
  .AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-content__J1sSs {
    min-width: 100%;
  }
  .AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-body__Cz2Ep {
    padding: 15px;
  }
  .AttendeeCustomTable_larg_model__UJOhp .AttendeeCustomTable_modal-content__J1sSs {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .AttendeeCustomTable_exer_modal_contain__OBVAt .AttendeeCustomTable_modal-dialog__lQ247 {
    max-width: 1055px;
  }
  .AttendeeCustomTable_delPopContainer__xhcoA .AttendeeCustomTable_modal-dialog__lQ247 {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 200px;
  }*/
}
/* vk new changes */
.AttendeeCustomTable_active_show_outer__8xIOk h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: "Plus Jakarta Sans", "Lufga", sans-serif !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl {
  width: 100%;
  display: block;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_img__HmdoN {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_img__HmdoN {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_img__HmdoN img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi {
  width: 100%;
  display: block;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi svg {
  flex-shrink: 0;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi .AttendeeCustomTable_act_box_bdg__RyeZr {
  width: 100%;
  margin-bottom: 12px;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi .AttendeeCustomTable_act_box_bdg__RyeZr span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi .AttendeeCustomTable_act_box_bdg__RyeZr .AttendeeCustomTable_sold__yDKjh {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.AttendeeCustomTable_active_show_outer__8xIOk .AttendeeCustomTable_active_show_inner__0XBsl .AttendeeCustomTable_act_box_cnt__CO0Vi p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}

/* vk new changes */
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_l__s4ZJ1 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: contain;
}
@media screen and (max-width: 767px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_l__s4ZJ1 img {
    object-fit: contain;
    width: auto;
  }
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 {
  flex: 1 1;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row__MRKC7 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44 {
  margin-bottom: 0px !important;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44.AttendeeCustomTable_interesting_fact__hV\\+i6 {
  padding-top: 30px;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44.AttendeeCustomTable_interesting_fact__hV\\+i6 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 {
  width: 100%;
}
.AttendeeCustomTable_attent_details__UE-T8 .AttendeeCustomTable_attent_details_inner__\\+5muo .AttendeeCustomTable_attent_details_inner_r__VBJS6 .AttendeeCustomTable_attent_details_row_last__2pV44.AttendeeCustomTable_interesting_fact__hV\\+i6 .AttendeeCustomTable_attent_details_row_box__Dcn\\+4 h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.AttendeeCustomTable_showbox_sec__YPor7 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  align-items: stretch;
  width: 100%;
}
@media screen and (max-width: 500px) {
  .AttendeeCustomTable_showbox_sec__YPor7 {
    grid-template-columns: 1fr;
  }
}

.AttendeeCustomTable_show_box_main__3PUud {
  margin: 10px 0px;
  width: 100%;
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy {
  min-height: 600px;
  width: 100%;
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy {
    min-height: 500px;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy .AttendeeCustomTable_active_show_inner__0XBsl {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy .AttendeeCustomTable_act_box_img__HmdoN {
  flex-shrink: 0;
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy .AttendeeCustomTable_act_box_cnt__CO0Vi {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy img {
  max-height: 400px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy img {
    max-height: 300px !important;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_show_box__ZKqsy:last-child {
  margin-right: 0;
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 {
    width: 250px !important;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 img {
    max-height: 350px !important;
  }
}
.AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .AttendeeCustomTable_show_box_main__3PUud .AttendeeCustomTable_no_show_box__gI-I1 h6 {
    font-size: 20px;
  }
}

.AttendeeCustomTable_attent_flex__LuDTd {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.AttendeeCustomTable_attent_flex__LuDTd h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

#AttendeeCustomTable_container__xcoZC {
  padding: 0px;
}
@media screen and (max-width: 768px) {
  #AttendeeCustomTable_container__xcoZC {
    padding: 0 16px;
  }
}
@media screen and (max-width: 480px) {
  #AttendeeCustomTable_container__xcoZC {
    padding: 0 12px;
  }
}

#AttendeeCustomTable_tableheading__GyDGF {
  font-size: 16px;
  margin-top: 20px;
}

.AttendeeCustomTable_search_box__QlVKg {
  position: relative;
}

thead .AttendeeCustomTable_CustomTable_tableheadlight__HuHZw__INszt th:first-child, thead .AttendeeCustomTable_CustomTable_tableheaddark__nwqb4__Ydh-G th:first-child {
  display: math !important;
}

#AttendeeCustomTable_spinner__P97Nm {
  float: right;
  margin-top: -25px;
  position: relative;
  z-index: 1;
  margin-right: 10px;
  cursor: pointer;
  color: #131F43;
}

.AttendeeCustomTable_tbl_sl__Sghd- {
  min-width: 10px !important;
}

.AttendeeCustomTable_tablebtn__GB0Ut {
  width: 70px;
  padding: 6px;
  border: none;
  background-color: #131F43;
  border-radius: 5px;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.AttendeeCustomTable_tablebtn__GB0Ut:hover {
  background-color: rgba(37, 105, 109, 0.864);
}

table {
  border-collapse: separate !important;
  border-spacing: 0 6px !important;
}

td:first-child,
th:first-child {
  border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
  border-radius: 0 8px 8px 0;
}

.AttendeeCustomTable_tableheaddiv__teRA8 {
  display: flex;
}

th, td {
  font-size: 14px;
}

th {
  padding: 0.8rem 1rem !important;
}

td {
  padding: 0.5rem 1rem !important;
  line-height: 28px;
}

.AttendeeCustomTable_sortbtn__47Ecs {
  border: none;
  background: none;
  color: #6E6E6E;
}

.AttendeeCustomTable_order_date__mmWt7 {
  margin-top: 5px;
  font-size: 12px;
  color: #000;
  font-weight: normal;
}

h6 {
  color: #000;
}

.AttendeeCustomTable_norecord__AfH9d {
  font-size: 22px;
  margin-top: 10px;
  color: #939090;
}

.AttendeeCustomTable_norecordsdiv__1\\+bE\\+ {
  position: absolute;
  left: 42%;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.AttendeeCustomTable_ststus_text__gewaA {
  font-size: 14px;
  font-weight: 600;
  padding-left: 8px;
}

.AttendeeCustomTable_ststus_not_verified__9EDWK {
  color: #9f9e9d;
}

.AttendeeCustomTable_ststus_verified__Xn1oa {
  color: #00ba00;
}

.AttendeeCustomTable_ststus_cancelled__Ywp6j {
  color: #ff0000;
}

.AttendeeCustomTable_ststus_pending__Mu9JM {
  color: #854d0e;
}

.AttendeeCustomTable_ststus_waitlisted__S1OCh {
  color: #5b21b6;
}

/* Ticket approval (free registration pending) — matches manager order-management pattern */
.AttendeeCustomTable_rowActionsTicketApproval__89Tlh {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.AttendeeCustomTable_approveTicketBtn__KdChC {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1.5px solid #bbf7d0;
  border-radius: 50%;
  cursor: pointer;
  background: #f0fdf4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s ease, border-color 0.18s ease;
  flex-shrink: 0;
}
.AttendeeCustomTable_approveTicketBtn__KdChC:hover:not(:disabled) {
  background: #bbf7d0;
  border-color: #86efac;
}
.AttendeeCustomTable_approveTicketBtn__KdChC:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.AttendeeCustomTable_rejectTicketBtn__YvXPu {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1.5px solid #fecaca;
  border-radius: 50%;
  cursor: pointer;
  background: #fff5f5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s ease, border-color 0.18s ease;
  flex-shrink: 0;
}
.AttendeeCustomTable_rejectTicketBtn__YvXPu:hover:not(:disabled) {
  background: #fecaca;
  border-color: #fca5a5;
}
.AttendeeCustomTable_rejectTicketBtn__YvXPu:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.AttendeeCustomTable_ticketApprovalActionSpinner__AWYV7 {
  width: 10px;
  height: 10px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: AttendeeCustomTable_ticketApprovalSpin__fSXnB 0.6s linear infinite;
}

@keyframes AttendeeCustomTable_ticketApprovalSpin__fSXnB {
  to {
    transform: rotate(360deg);
  }
}
.AttendeeCustomTable_ticketConfirmOverlay__eG9tt {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.AttendeeCustomTable_ticketConfirmCard__lXYbi {
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px 24px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.AttendeeCustomTable_ticketConfirmIconWrap__mKjca {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.AttendeeCustomTable_ticketConfirmIconApprove__PBJ6n {
  background: #dcfce7;
}

.AttendeeCustomTable_ticketConfirmIconReject__0onWz {
  background: #fee2e2;
}

.AttendeeCustomTable_ticketConfirmTitle__rer14 {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  text-align: center;
}

.AttendeeCustomTable_ticketConfirmBody__FuF5j {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
  text-align: center;
  margin: 0;
}
.AttendeeCustomTable_ticketConfirmBody__FuF5j strong {
  color: #111827;
}

.AttendeeCustomTable_ticketWaitlistNote__MuseL {
  font-size: 14px;
  color: #5b21b6;
  line-height: 1.55;
  text-align: center;
  margin: 0 0 10px;
  padding: 12px 14px;
  background: #f5f3ff;
  border-radius: 10px;
  border: 1px solid #ddd6fe;
  width: 100%;
  box-sizing: border-box;
}
.AttendeeCustomTable_ticketWaitlistNote__MuseL strong {
  color: #4c1d95;
}

.AttendeeCustomTable_ticketConfirmActions__eihlQ {
  display: flex;
  gap: 10px;
  margin-top: 8px;
  width: 100%;
  justify-content: center;
}

.AttendeeCustomTable_ticketConfirmCancelBtn__DtSEi {
  flex: 1 1;
  padding: 10px 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.AttendeeCustomTable_ticketConfirmCancelBtn__DtSEi:hover {
  background: #f9fafb;
}

.AttendeeCustomTable_ticketConfirmApproveBtn__dlpI2 {
  flex: 1 1;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background: #16a34a;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.AttendeeCustomTable_ticketConfirmApproveBtn__dlpI2:hover {
  background: #15803d;
}

.AttendeeCustomTable_ticketConfirmRejectBtn__XLSzn {
  flex: 1 1;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background: #dc2626;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.AttendeeCustomTable_ticketConfirmRejectBtn__XLSzn:hover {
  background: #b91c1c;
}

.AttendeeCustomTable_refund__-dSx6 {
  padding-left: 10px;
}

.AttendeeCustomTable_refund__-dSx6 button {
  padding: 0;
  background-color: transparent;
  border: none;
}

.AttendeeCustomTable_refund__-dSx6 button:hover {
  background-color: transparent;
  border: none;
  box-shadow: none;
  outline: none;
}

.AttendeeCustomTable_refund__-dSx6 button:active {
  background-color: transparent;
  border: none;
  box-shadow: none;
  outline: none;
}

.AttendeeCustomTable_refund__-dSx6 button:focus {
  background-color: transparent;
  border: none;
  box-shadow: none !important;
  outline: none;
}

.AttendeeCustomTable_refund_tooltip__Bg-mU {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.AttendeeCustomTable_refund_tooltip__Bg-mU .AttendeeCustomTable_tooltiptext__r6xdz {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
}

.AttendeeCustomTable_refund_tooltip__Bg-mU:hover .AttendeeCustomTable_tooltiptext__r6xdz {
  visibility: visible;
}

.AttendeeCustomTable_search_contain_box__OcQ1e {
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.AttendeeCustomTable_search_contain_box1__DdZQY {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin: 20px 0;
}

.AttendeeCustomTable_tabbtn__2KYu\\+ {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  align-items: center;
}
@media screen and (max-width: 480px) {
  .AttendeeCustomTable_tabbtn__2KYu\\+ {
    justify-content: flex-start;
    gap: 0.5rem;
  }
}

.AttendeeCustomTable_totalamt__LT2p4 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #EAEAEA;
  color: var(--Font-black, #0B0D0F);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  height: 42px;
  padding: 10px;
}

.AttendeeCustomTable_totalamt__LT2p4 span {
  color: var(--Green, #00C16B);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.AttendeeCustomTable_totalamt1__Jpdbh {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #EAEAEA;
  color: var(--Font-black, #0B0D0F);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  height: 42px;
  padding: 10px;
}

.AttendeeCustomTable_search_contain_box1__DdZQY h5 {
  margin: 0 !important;
  padding: 0 !important;
}

.AttendeeCustomTable_eventHeaderRow__RQHSV {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.AttendeeCustomTable_viewEventDetailsBtn__Wi40z {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #CD47F3;
  background: transparent;
  border: 1px solid #CD47F3;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}
.AttendeeCustomTable_viewEventDetailsBtn__Wi40z:hover {
  background-color: #CD47F3;
  color: #fff;
}
.AttendeeCustomTable_viewEventDetailsBtn__Wi40z:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(205, 71, 243, 0.3);
}

.AttendeeCustomTable_totalamt1__Jpdbh ul {
  list-style: none;
  display: flex;
  gap: 10px;
  padding: 0 !important;
  margin: 0;
}

.AttendeeCustomTable_totalamt1__Jpdbh span {
  color: var(--Primary, #FD9800);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.AttendeeCustomTable_Total_count__KQSZL {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 20px;
  margin-right: 15px;
  justify-content: flex-end;
}

.AttendeeCustomTable_Total_seat_count__z-M-N {
  font-size: 16px;
  font-weight: 700;
}

.AttendeeCustomTable_Total_seat_count__z-M-N span {
  background: #07bf0d;
  padding: 5px;
  border-radius: 3px;
  color: #fff;
}

.AttendeeCustomTable_user_tb_hd__avwA4 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 {
  background-color: #D1ECF1;
  border: solid 1px #BEE5EB;
  border-radius: 4px;
  padding: 10px 20px;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  min-height: 45px;
  height: auto;
  flex: 1 1 auto;
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 .AttendeeCustomTable_info_content__HN7om {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
@media screen and (max-width: 767px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 .AttendeeCustomTable_info_content__HN7om {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 p {
  margin: 0;
  color: #0C5460;
  font-size: 15px;
  font-weight: 500;
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 button {
  height: unset;
  background-color: transparent;
  border: none;
  padding: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0C5460;
  text-decoration: underline;
  white-space: nowrap;
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 button:hover {
  color: #1492a7;
}
.AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 button:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
@media screen and (max-width: 767px) {
  .AttendeeCustomTable_user_tb_hd__avwA4 .AttendeeCustomTable_info_contain__Me548 {
    width: 100%;
    padding: 12px 16px;
  }
}

.AttendeeCustomTable_sectionright__VsLJr {
  float: right;
  display: flex;
  gap: 30px;
}
.AttendeeCustomTable_sectionright__VsLJr #AttendeeCustomTable_dropdown__8ExS4 {
  margin: 0px 10px 10px 10px;
}
.AttendeeCustomTable_sectionright__VsLJr #AttendeeCustomTable_dropdown__8ExS4 button {
  background-color: #131F43;
  border-radius: 5px;
  border: none;
  box-shadow: none;
  font-size: 14px;
  min-width: 140px;
  min-height: 44px;
}
.AttendeeCustomTable_sectionright__VsLJr a {
  font-size: 14px;
}
.AttendeeCustomTable_sectionright__VsLJr #AttendeeCustomTable_del_icon__oWLMh {
  font-size: 12px;
  margin-left: 5px;
}

.AttendeeCustomTable_tdactive__Q9CO8 {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  margin-top: 8px;
  background: rgba(0, 193, 107, 0.2);
  color: #00C16B;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.AttendeeCustomTable_tdinactive__0HIXZ {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(255, 0, 0, 0.2);
  color: #F00;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.AttendeeCustomTable_tdyellowbg__PbpMV {
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(253, 152, 0, 0.2);
  color: #FD9800;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8px;
}

.AttendeeCustomTable_arrowback__jXmv0 {
  margin-bottom: 0px;
  cursor: pointer;
}

.AttendeeCustomTable_searchcontainer__mlndk {
  display: flex;
  justify-content: end;
}

.AttendeeCustomTable_searchcontainer_inner__-CWtR {
  display: flex;
  justify-content: end;
  flex-direction: column;
}

.AttendeeCustomTable_attent_flex_contain__q1YYz {
  display: block;
}

.AttendeeCustomTable_attent_flex_contain__q1YYz h5 {
  margin: 20px 0px;
}

.AttendeeCustomTable_pay_btn__SUh-t {
  margin-right: 10px;
}

.AttendeeCustomTable_count_contain__JIQHT {
  display: flex;
  flex-direction: column;
}
.AttendeeCustomTable_count_contain__JIQHT .AttendeeCustomTable_totalamt1__Jpdbh {
  height: auto;
}

tr:nth-child(even) {
  background-color: #fcfcfc;
}

.AttendeeCustomTable_onboardsty__v6x7b {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

/* ── Tablet & below (≤1230px) ── */
@media screen and (max-width: 1230px) {
  .AttendeeCustomTable_onboardsty__v6x7b {
    flex-direction: column;
    align-items: stretch;
  }
  .AttendeeCustomTable_onboardsty__v6x7b button {
    width: 100%;
  }
  .AttendeeCustomTable_user_tb_hd__avwA4 {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}
/* ── ≤1250px: stat/search containers stack ── */
@media only screen and (max-width: 1250px) {
  .AttendeeCustomTable_search_contain_box1__DdZQY {
    flex-direction: column;
  }
}
/* ── ≤1350px: inner search container ── */
@media only screen and (max-width: 1350px) {
  .AttendeeCustomTable_searchcontainer_inner__-CWtR {
    display: unset;
  }
}
/* ── Tablet (≤992px) ── */
@media only screen and (max-width: 992px) {
  .AttendeeCustomTable_search_contain_box__OcQ1e {
    flex-direction: column;
    align-items: stretch;
  }
  .AttendeeCustomTable_search_contain_box__OcQ1e input {
    min-width: 100% !important;
    width: 100% !important;
  }
  .AttendeeCustomTable_tabbtn__2KYu\\+ {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
  }
  .AttendeeCustomTable_tabbtn__2KYu\\+ button,
.AttendeeCustomTable_tabbtn__2KYu\\+ a {
    flex: 1 1 auto;
    min-width: 120px;
    justify-content: center;
    white-space: nowrap;
  }
  .AttendeeCustomTable_Total_count__KQSZL {
    flex-direction: column;
    justify-content: flex-start;
    align-items: baseline;
    margin-right: 0;
  }
  .AttendeeCustomTable_Total_seat_count__z-M-N {
    font-size: 14px;
  }
}
/* ── Mobile (≤768px) ── */
@media only screen and (max-width: 768px) {
  .AttendeeCustomTable_attent_flex_contain__q1YYz h5 {
    margin: 14px 0;
    font-size: 16px;
  }
  .AttendeeCustomTable_search_contain_box1__DdZQY {
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;
  }
  .AttendeeCustomTable_search_contain_box__OcQ1e {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 16px;
    gap: 10px;
  }
  .AttendeeCustomTable_search_contain_box__OcQ1e input {
    min-width: 100% !important;
    width: 100% !important;
  }
  .AttendeeCustomTable_search_contain__hxCOj {
    width: 100%;
  }
  .AttendeeCustomTable_tabbtn__2KYu\\+ {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    align-items: stretch;
  }
  .AttendeeCustomTable_tabbtn__2KYu\\+ button,
.AttendeeCustomTable_tabbtn__2KYu\\+ a {
    width: 100% !important;
    min-width: unset !important;
    justify-content: center;
  }
  .AttendeeCustomTable_export_btn__05vaH {
    min-width: unset !important;
  }
  .AttendeeCustomTable_count_contain__JIQHT {
    gap: 12px;
  }
  .AttendeeCustomTable_sectionright__VsLJr {
    float: none;
    gap: 8px;
    flex-direction: column;
  }
  .AttendeeCustomTable_user_tb_hd__avwA4 {
    flex-direction: column;
    gap: 10px;
  }
  .AttendeeCustomTable_info_contain__Me548 {
    height: auto !important;
    flex-direction: column;
    padding: 12px 16px !important;
  }
}
/* ── Small mobile (≤600px) ── */
@media only screen and (max-width: 600px) {
  #AttendeeCustomTable_dashboardcont2__fOe6q {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 10px;
  }
  .AttendeeCustomTable_totalamt1__Jpdbh ul {
    flex-direction: column;
  }
  .AttendeeCustomTable_tabbtn__2KYu\\+ {
    grid-template-columns: 1fr;
  }
}
/* ── Extra small (≤480px) ── */
@media only screen and (max-width: 480px) {
  .AttendeeCustomTable_searchcontainer_inner__-CWtR {
    align-items: stretch;
  }
  .AttendeeCustomTable_search_contain_box1__DdZQY {
    align-items: stretch;
  }
  .AttendeeCustomTable_arrowback__jXmv0 {
    font-size: 14px;
  }
  .AttendeeCustomTable_count_box_contain__OTD6y {
    padding: 14px;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y {
  background-color: #fff;
  border-radius: 5px;
  padding: 24px 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
@media screen and (max-width: 992px) {
  .AttendeeCustomTable_count_box_contain__OTD6y {
    gap: 20px;
    padding: 20px;
  }
}
@media screen and (max-width: 480px) {
  .AttendeeCustomTable_count_box_contain__OTD6y {
    padding: 14px;
    gap: 16px;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
}
.AttendeeCustomTable_count_box_contain__OTD6y ul li {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(20% - 16px);
  min-width: 90px;
}
@media screen and (max-width: 1024px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 16px);
  }
}
@media screen and (max-width: 576px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 12px);
  }
}
@media screen and (max-width: 360px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li {
    flex: 1 1 100%;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_text__chW1- {
  font-size: 13px;
  font-weight: 600;
  color: #727272;
}
@media screen and (min-width: 1245px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_text__chW1- {
    font-size: 15px;
  }
}
.AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_num__IA57o {
  font-size: 18px;
  font-weight: 700;
  color: #131F43;
}
@media screen and (min-width: 1245px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_num__IA57o {
    font-size: 22px;
  }
}
@media screen and (max-width: 480px) {
  .AttendeeCustomTable_count_box_contain__OTD6y ul li .AttendeeCustomTable_count_num__IA57o {
    font-size: 16px;
  }
}

.AttendeeCustomTable_export_btn__05vaH {
  font-size: 15px;
  font-weight: 600;
  color: #131F43 !important;
  border: solid 1px #131F43 !important;
  border-radius: 5px;
  background-color: transparent !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 10px 20px !important;
  white-space: nowrap;
  min-width: unset;
}

.AttendeeCustomTable_export_btn__05vaH svg {
  fill: #131F43;
  flex-shrink: 0;
}

.AttendeeCustomTable_export_btn__05vaH:hover {
  color: #fff !important;
  border-color: #131F43 !important;
  background-color: #131F43 !important;
}

.AttendeeCustomTable_export_btn__05vaH:hover svg {
  fill: #fff;
}

@media screen and (max-width: 1200px) {
  .AttendeeCustomTable_table_attendee__qMqyb th {
    min-width: 140px;
  }
}
@media screen and (max-width: 998px) {
  .AttendeeCustomTable_table_attendee__qMqyb th {
    min-width: 150px;
  }
}
@media screen and (max-width: 480px) {
  .AttendeeCustomTable_table_attendee__qMqyb th {
    min-width: 100px;
    font-size: 12px;
    padding: 0.5rem 0.75rem !important;
  }
}
@media screen and (max-width: 480px) {
  .AttendeeCustomTable_table_attendee__qMqyb td {
    font-size: 12px;
    padding: 0.4rem 0.75rem !important;
  }
}

@media screen and (max-width: 768px) {
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AttendeeCustomTable/AttendeeCustomTable.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAmDC;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,gBAAA;ADvEH;;AC0EC;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ADvEH;;AC0EC;;;EAGE,yBAnEoB;ADJvB;;AC0EC;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADvEH;;AC0EC;;CAAA;AAIA;EACE,wBAzCU;EA0CV,UAzCS;EA0CT,kBAAA;EACA,aAjDiB;EAkDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ADrEH;;AC2EC;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADxEH;;AC6EC;EACE,2BAAA;AD1EH;;AC6EC;EACE,yBAAA;EACA,YAAA;AD1EH;;AC8EC;EACE,YAAA;AD3EH;;AC8EC;EACE,sBA9GY;ADmCf;;AC8EC;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AD3EH;;AC8EC;EACE,yBArIgB;EAsIhB,iBAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAlIY;ADuDf;;AC8EC;EACE,yBAjJgB;ADsEnB;;AC8EC;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAvJY;AD4Ef;;AC8EC;EACE,yBAtKgB;AD2FnB;;AC8EC;;CAAA;AAGA;EACE,yBAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;;EAEE,sBAAA;AD3EH;;AC8EC;EACE,yBAxLsB;EAyLtB,cAnMkB;ADwHrB;;AC8EC;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;;EAEE,qBAAA;AD3EH;;AC8EC;EACE,yBAjOsB;EAkOtB,WAzNY;AD8If;;AC8EC;;CAAA;AAGA;EACE,cA7Ne;ADkJlB;;AC8EC;EACE,cAjOe;ADsJlB;;AC8EC;;CAAA;AAGA;EACE,sBA3OY;EA4OZ,YAAA;AD3EH;;AC8EC;EACE,yBA3PgB;EA4PhB,WAjPY;EAkPZ,YAAA;AD3EH;;AC8EC;EACE,cAnPe;ADwKlB;;AC8EC;;CAAA;AAGA;EACE,yBA3Sc;EA4Sd,8BAAA;AD3EH;;AC8EC;EACE,WAlQY;ADuLf;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,oCAAA;EACA,gCAAA;AD3EH;;AC8EC;EACE,yBArRkB;EAsRlB,WA9RY;ADmNf;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,iBAAA;AD3EH;;AC8EC;;EAEE,+BAAA;EACA,iBAAA;AD3EH;;AC8EC;EACE,sBAhTY;ADqOf;AC6EG;EACE,sBAnTU;EAoTV,YAAA;AD3EL;;AC+EC;EACE,0CAAA;EACA,cAvTe;AD2OlB;AC8EG;EACE,yCAAA;EACA,eAAA;AD5EL;;ACgFC;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;;CAAA;AAGA;EACE,sBAnVY;EAoVZ,yBAAA;EACA,qDAAA;AD7EH;;ACgFC;EACE,yBAjVkB;EAkVlB,yBAAA;EACA,eAAA;AD7EH;AC+EG;EACE,cA3Va;AD8QlB;;ACkFC;;CAAA;AAGA;EACE,yBA1WgB;AD2RnB;;ACkFC;EACE,yBAAA;EACA,yBAAA;AD/EH;;ACkFC;EACE,yBA1XoB;EA2XpB,yBAAA;AD/EH;;ACkFC;EACE,UAAA;EACA,eAAA;EACA,eAAA;AD/EH;;ACkFC;;CAAA;AAGA;EACE,sBA9XY;AD+Sf;;ACkFC;EACE,yBA1XkB;AD2SrB;;ACmFC;;CAAA;AAGA;EACE,iGAAA;EACA,sBA3YY;AD2Tf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBApZY;ADoUf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBA7ZY;AD6Uf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBAtaY;ADsVf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;;;;;;;;EAQE,WArbY;ADqWf;;ACmFC;;CAAA;AAGA;EACE,qCAAA;ADhFH;;ACmFC;EACE,cA7be;AD6WlB;;ACoFC;;CAAA;AAGA;EACE,sBAAA;ADjFH;;ACoFC;EACE,yBAAA;ADjFH;;ACoFC;EACE,yBAjekB;EAkelB,WAjdY;ADgYf;;ACoFC;EACE,yBAtekB;EAuelB,WAtdY;ADqYf;;ACoFC;EACE,6BAAA;ADjFH;;ACoFC;EACE,2BAAA;ADjFH;;ACoFC;EACE,yBAnfkB;ADkarB;;ACoFC;EACE,yBAtfwB;ADqa3B;;ACoFC;EACE,WA1eY;EA2eZ,6BAAA;EACA,yBAAA;ADjFH;;ACqFC;EACE,yBA5fgB;AD0anB;;ACqFC;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ADlFH;;ACqFC;;;EAGE,oCAAA;EACA,sBAAA;ADlFH;;ACqFC;EACE,gBAAA;EACA,YAAA;EACA,WAxgBY;EAygBZ,yBAriBY;EAsiBZ,YAAA;EACA,eAAA;EACA,gBAhkBc;AD8ejB;;ACqFE;EACC,gBAAA;EACA,YAAA;EACA,WAlhBY;EAmhBZ,yBA/iBY;EAgjBZ,YAAA;EACA,eAAA;EACA,gBA1kBc;ADwfjB;;ACqFC;EACE,yBAtjBY;ADoef;;ACqFC;EACE,yBA/iBkB;AD6drB;;ACqFC;EACE,yBAljBwB;ADge3B;;ACqFC;EACE,cAxjBiB;ADsepB;;ACsFC;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADnFH;;ACsFC;EACE,WAjjBY;EAkjBZ,yBA9kBY;EA+kBZ,YAAA;ADnFH;;ACsFC;EACE,QAAA;ADnFH;;ACuFC;EACE,gBAAA;EACA,YAAA;EACA,yBAnlBW;EAolBX,WA/jBY;EAgkBZ,eAAA;EACA,gBArnBc;EAsnBd,YAAA;ADpFH;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFH;;ACuFC;;;EAGE,yBA1mBW;EA2mBX,WAtlBY;EAulBZ,YAAA;ADpFH;;ACuFC;EACC,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,oCAAA;ADpFF;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;;;EAGE,oCAAA;ADpFH;;ACuFC;EACC,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFF;;ACyFC;EACE,aAAA;EACA,kBAAA;ADtFH;;ACyFC;EACE,mBAAA;ADtFH;;ACyFC;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ADtFH;;ACyFC;EACE,UAAA;ADtFH;;ACyFC;EACE,yCA7pBc;EA8pBd,cAlqBkB;AD4kBrB;;ACyFC;EACE,aAtqBkB;ADglBrB;;ACyFC;EACE,yBAlqBgB;AD4kBnB;;ACyFC;EACE,yBAAA;ADtFH;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WAjqBY;AD2kBf;;ACyFC;;EAEE,yBAvrBkB;EAwrBlB,WAvqBY;ADilBf;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WA7qBY;ADulBf;;ACyFC;EACE,yBA1rBsB;EA2rBtB,WAlrBY;AD4lBf;;ACyFC;;;EAGE,WAxrBY;ADkmBf;;ACyFC;;EAEE,yBAxsBgB;EAysBhB,WA9rBY;ADwmBf;;ACyFC;EACE,yBAjvBO;AD2pBV;;ACyFC;EACE,eAjtBgB;AD2nBnB;;ACyFC;EACE,YA1sBY;ADonBf;;ACyFC;;EAEE,sBAAA;ADtFH;;ACyFC,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AD1FH;;AC6FC;EACE,0BAAA;AD1FH;;AC6FC;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AD1FH;;AC6FC;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AD1FH;;AC6FC;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AD1FH;;AC6FC;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AD1FH;;AC6FC;;EAEE,0BAAA;EACA,aAAA;AD1FH;;AC6FC;EACE,kBAAA;AD1FH;;AC6FC;EACE;IACE,gBAAA;ED1FH;AACF;AC6FC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kBAAA;ED3FH;EC8FC;IACE,2BAAA;IACA,gBAAA;ED5FH;AACF;AC+FC;EACE;;IAAA;EAGA;;IAAA;AD3FH;ACgGC;EACE;IACE,uBAAA;ED9FH;ECgGD;IACE,0BAAA;IACA,2BAAA;ED9FD;ECgGC;IACE,6BAAA;ED9FH;AACF;ACiGC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;ED/FH;ECkGC;;IAEE,kBAAA;EDhGH;ECmGC;IACE,eAAA;EDjGH;ECoGC;IACE,aAAA;EDlGH;ECqGC;IACE,8BAAA;IACA,aAAA;EDnGH;AACF;ACsGC;EACE;IACE,iBAAA;EDpGH;ECuGC;IACE,gBAAA;EDrGH;ECwGC;;IAAA;ADpGH;ACyGC,mBAAA;AAGA;EACE,iCAAA;EACA,gEAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADzGH;AC4GG;EACE,WAAA;EACA,cAAA;AD1GL;AC4GK;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AD1GP;AC2GO;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;EDxGP;AACF;ACyGO;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ADvGT;AC2GK;EACE,WAAA;EACA,cAAA;ADzGP;AC0GC;EACC,cAAA;ADxGF;AC0GO;EACE,WAAA;EACA,mBAAA;ADxGT;AC0GS;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADxGX;AC2GS;EACE,kFAAA;ADzGX;AC8GO;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AD5GT;AC+GO;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AD7GT;AC+GS;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AD7GX;;ACoHC,mBAAA;AAEE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ADlHL;ACoHK;EATF;IAUI,yBAAA;EDjHL;AACF;ACmHK;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EDhHL;AACF;ACmHO;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;ADjHT;ACkHS;EALF;IAMG,mBAAA;IACA,WAAA;ED/GR;AACF;ACmHK;EACE,SAAA;ADjHP;ACmHO;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ADjHT;ACmHS;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;EDhHT;AACF;ACkHS;EACE,SAAA;EACA,UAAA;ADhHX;ACkHW;EAJF;IAKI,gCAAA;IACA,sBAAA;ED/GX;AACF;ACiHW;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ED9GX;AACF;ACgHW;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD9Gb;ACiHW;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AD/Gb;ACoHM;EACE,6BAAA;ADlHR;ACmHQ;EACE,iBAAA;ADjHV;ACkHU;EACE,WAAA;ADhHZ;ACiHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AD/Gd;;ACuHC;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;ADpHH;ACqHG;EANF;IAOI,0BAAA;EDlHH;AACF;;ACoHC;EACE,gBAAA;EACA,WAAA;ADjHH;ACmHG;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;ADjHL;ACmHK;EATF;IAUI,iBAAA;EDhHL;AACF;ACkHK;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ADhHP;ACmHK;EACE,cAAA;ADjHP;ACoHK;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;ADlHP;ACqHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ADnHP;ACqHO;EANF;IAOI,4BAAA;EDlHP;AACF;ACqHK;EACE,eAAA;ADnHP;ACuHG;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ADrHL;ACuHK;EALF;IAMI,uBAAA;EDpHL;AACF;ACsHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ADpHP;ACsHO;EALF;IAMI,4BAAA;EDnHP;AACF;ACqHK;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ADnHP;ACoHO;EARF;IASI,eAAA;EDjHP;AACF;;ACwHC;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ADrHH;ACuHG;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ADrHL;;AAhlCA;EACE,YAAA;AAmlCF;AAllCE;EAFF;IAGI,eAAA;EAqlCF;AACF;AAplCE;EALF;IAMI,eAAA;EAulCF;AACF;;AAplCA;EACI,eAAA;EACA,gBAAA;AAulCJ;;AAplCA;EACE,kBAAA;AAulCF;;AAplCA;EACE,wBAAA;AAulCF;;AAplCA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cCqCkB;ADkjCpB;;AAplCA;EACE,0BAAA;AAulCF;;AAplCA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBC0BgB;EDzBhB,kBAAA;EACA,WCWW;EDVX,gBAAA;EACA,mBAAA;EACA,eAAA;AAulCJ;AArlCI;EACE,2CCmBgB;ADokCtB;;AAnlCA;EACI,oCAAA;EACA,gCAAA;AAslCJ;;AAllCA;;EAEI,0BAAA;AAqlCJ;;AAjlCA;;EAEI,0BAAA;AAolCJ;;AAjlCA;EACE,aAAA;AAolCF;;AAllCE;EACE,eAAA;AAqlCJ;;AAhlCE;EACE,+BAAA;AAmlCJ;;AAhlCE;EACE,+BAAA;EACA,iBAAA;AAmlCJ;;AAvkCA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;AA0kCF;;AAvkCA;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AA0kCJ;;AAvkCA;EACE,WAAA;AA0kCF;;AAtkCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAykCJ;;AAvkCE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA0kCJ;;AAvkCA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA0kCF;;AAvkCA;EACE,cAAA;AA0kCF;;AAvkCA;EACE,cAAA;AA0kCF;;AAvkCA;EACE,cAAA;AA0kCF;;AAvkCA;EACE,cAAA;AA0kCF;;AAvkCA;EACE,cAAA;AA0kCF;;AAvkCA,2FAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA0kCF;;AAvkCA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0DAAA;EACA,cAAA;AA0kCF;AAxkCE;EACE,mBAAA;EACA,qBAAA;AA0kCJ;AAvkCE;EACE,YAAA;EACA,mBAAA;AAykCJ;;AArkCA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0DAAA;EACA,cAAA;AAwkCF;AAtkCE;EACE,mBAAA;EACA,qBAAA;AAwkCJ;AArkCE;EACE,YAAA;EACA,mBAAA;AAukCJ;;AAnkCA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,6EAAA;AAskCF;;AAnkCA;EACE;IACE,yBAAA;EAskCF;AACF;AAnkCA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAqkCF;;AAlkCA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAqkCF;;AAlkCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAqkCF;;AAlkCA;EACE,mBAAA;AAqkCF;;AAlkCA;EACE,mBAAA;AAqkCF;;AAlkCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAqkCF;;AAlkCA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAqkCF;AAnkCE;EACE,cAAA;AAqkCJ;;AAjkCA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAokCF;AAlkCE;EACE,cAAA;AAokCJ;;AAhkCA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AAmkCF;;AAhkCA;EACE,SAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAmkCF;AAjkCE;EACE,mBAAA;AAmkCJ;;AA/jCA;EACE,SAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAkkCF;AAhkCE;EACE,mBAAA;AAkkCJ;;AA9jCA;EACE,SAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAikCF;AA/jCE;EACE,mBAAA;AAikCJ;;AA7jCA;EACE,kBAAA;AAgkCF;;AA7jCA;EACE,UAAA;EACA,6BAAA;EACA,YAAA;AAgkCF;;AA7jCA;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAgkCF;;AA7jCA;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAgkCF;;AA7jCA;EACE,6BAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;AAgkCF;;AA5jCA;EACE,kBAAA;EACA,qBAAA;EACA,+BAAA;AA+jCF;;AA5jCA;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA+jCF;;AA3jCA;EACE,mBAAA;AA8jCF;;AA3jCA;EACE,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AA8jCF;;AA5jCA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;AA+jCF;;AA7jCA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAgkCF;AA/jCE;EALF;IAMI,2BAAA;IACA,WAAA;EAkkCF;AACF;;AAhkCA;EACE,aAAA;EACF,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAmkCA;;AAhkCA;EACE,4BAAA;EACF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAmkCA;;AAjkCA;EACE,aAAA;EACF,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAokCA;;AAjkCA;EACE,oBAAA;EACA,qBAAA;AAokCF;;AAjkCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAokCF;;AAjkCA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;AAokCF;AAlkCE;EACE,yBAAA;EACA,WAAA;AAokCJ;AAjkCE;EACE,aAAA;EACA,6CAAA;AAmkCJ;;AAhkCA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;EACA,SAAA;AAmkCF;;AAhkCA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAmkCA;;AAjkCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAokCF;;AAjkCA;EACE,eAAA;EACA,gBAAA;AAokCF;;AAjkCA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAokCF;;AAjkCA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAokCF;AAlkCE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAokCJ;AAlkCI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAokCN;AAlkCM;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,QAAA;EAqkCN;AACF;AAlkCI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAokCN;AAjkCI;EACE,aAAA;EACA,6BAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;AAmkCN;AAjkCM;EACE,cAAA;AAmkCR;AAjkCM;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAmkCR;AA/jCI;EAtDF;IAuDI,WAAA;IACA,kBAAA;EAkkCJ;AACF;;AA9jCA;EACE,YAAA;EACA,aAAA;EACA,SAAA;AAikCF;AA/jCE;EACE,0BAAA;AAikCJ;AA/jCE;EACI,yBCtjBc;EDujBd,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAikCN;AA/jCE;EACI,eAAA;AAikCN;AA9jCE;EACE,eAAA;EACA,gBAAA;AAgkCJ;;AA5jCA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA+jCF;;AA3jCA;EACE,iBAAA;EACF,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA8jCA;;AA3jCA;EACE,iBAAA;EACF,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA8jCA;;AA3jCA;EACE,kBAAA;EACA,eAAA;AA8jCF;;AA3jCA;EACE,aAAA;EACA,oBAAA;AA8jCF;;AA3jCA;EACI,aAAA;EACA,oBAAA;EACA,sBAAA;AA8jCJ;;AA3jCA;EACE,cAAA;AA8jCF;;AA3jCA;EACE,gBAAA;AA8jCF;;AA3jCA;EACE,kBAAA;AA8jCF;;AA3jCA;EACE,aAAA;EACA,sBAAA;AA8jCF;AA7jCE;EACE,YAAA;AA+jCJ;;AA1jCA;EACE,yBAAA;AA6jCF;;AA1jCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA6jCF;;AA1jCA,mCAAA;AACA;EACE;IACE,sBAAA;IACA,oBAAA;EA6jCF;EA3jCA;IACE,WAAA;EA6jCF;EA3jCA;IACE,sBAAA;IACA,SAAA;IACA,uBAAA;EA6jCF;AACF;AA1jCA,gDAAA;AACA;EACE;IACE,sBAAA;EA4jCF;AACF;AAzjCA,0CAAA;AACA;EACE;IACE,cAAA;EA2jCF;AACF;AAxjCA,0BAAA;AACA;EACE;IACE,sBAAA;IACA,oBAAA;EA0jCF;EAxjCA;IACE,0BAAA;IACA,sBAAA;EA0jCF;EAxjCA;IACE,mBAAA;IACA,eAAA;IACA,mBAAA;IACA,WAAA;EA0jCF;EAxjCA;;IAEE,cAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EA0jCF;EAxjCA;IACE,sBAAA;IACA,2BAAA;IACA,qBAAA;IACA,eAAA;EA0jCF;EAxjCA;IACE,eAAA;EA0jCF;AACF;AAvjCA,0BAAA;AACA;EACE;IACE,cAAA;IACA,eAAA;EAyjCF;EAvjCA;IACE,sBAAA;IACA,SAAA;IACA,cAAA;EAyjCF;EAvjCA;IACE,sBAAA;IACA,oBAAA;IACA,mBAAA;IACA,SAAA;EAyjCF;EAvjCA;IACE,0BAAA;IACA,sBAAA;EAyjCF;EAvjCA;IACE,WAAA;EAyjCF;EAvjCA;IACE,aAAA;IACA,qCAAA;IACA,QAAA;IACA,oBAAA;EAyjCF;EAvjCA;;IAEE,sBAAA;IACA,2BAAA;IACA,uBAAA;EAyjCF;EAvjCA;IACE,2BAAA;EAyjCF;EAvjCA;IACE,SAAA;EAyjCF;EAvjCA;IACE,WAAA;IACA,QAAA;IACA,sBAAA;EAyjCF;EAvjCA;IACE,sBAAA;IACA,SAAA;EAyjCF;EAvjCA;IACE,uBAAA;IACA,sBAAA;IACA,6BAAA;EAyjCF;AACF;AAtjCA,gCAAA;AACA;EACE;IACE,wBCvxBS;IDwxBT,UCvxBQ;IDwxBR,kBAAA;IACA,aAAA;EAwjCF;EAtjCA;IACE,sBAAA;EAwjCF;EAtjCA;IACE,0BAAA;EAwjCF;AACF;AArjCA,+BAAA;AACA;EACE;IACE,oBAAA;EAujCF;EArjCA;IACE,oBAAA;EAujCF;EArjCA;IACE,eAAA;EAujCF;EArjCA;IACE,aAAA;EAujCF;AACF;AAnjCA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAqjCF;AAnjCE;EATF;IAUI,SAAA;IACA,aAAA;EAsjCF;AACF;AArjCE;EAbF;IAcI,aAAA;IACA,SAAA;EAwjCF;AACF;AAtjCE;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AAwjCJ;AAtjCI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EAAA,cAAA;EAAA,4BAAA;EACA,eAAA;AAwjCN;AAtjCM;EARF;IASI,YAAA;IAAA,cAAA;IAAA,+BAAA;EAyjCN;AACF;AAxjCM;EAXF;IAYI,YAAA;IAAA,cAAA;IAAA,4BAAA;EA2jCN;AACF;AA1jCM;EAdF;IAeI,cAAA;EA6jCN;AACF;AA3jCM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA6jCR;AA3jCQ;EALF;IAMI,eAAA;EA8jCR;AACF;AA3jCM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA6jCR;AA3jCQ;EALF;IAMI,eAAA;EA8jCR;AACF;AA7jCQ;EARF;IASI,eAAA;EAgkCR;AACF;;AA1jCA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,wCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AA6jCF;;AA1jCA;EACE,aAAA;EACA,cAAA;AA6jCF;;AA1jCA;EACE,sBAAA;EACA,gCAAA;EACA,oCAAA;AA6jCF;;AA1jCA;EACE,UAAA;AA6jCF;;AAxjCI;EADF;IAEI,gBAAA;EA4jCJ;AACF;AA3jCI;EAJF;IAKI,gBAAA;EA8jCJ;AACF;AA7jCI;EAPF;IAQI,gBAAA;IACA,eAAA;IACA,kCAAA;EAgkCJ;AACF;AA7jCI;EADF;IAEI,eAAA;IACA,kCAAA;EAgkCJ;AACF;;AA3jCA;EACE;IACE,gBAAA;IACA,iCAAA;EA8jCF;AACF","sourcesContent":["@import \"/src/styles/Variables/Variables.scss\";\n\n\n#container {\n  padding: 0px;\n  @media screen and (max-width: 768px) {\n    padding: 0 16px;\n  }\n  @media screen and (max-width: 480px) {\n    padding: 0 12px;\n  }\n}\n\n#tableheading{\n    font-size: 16px;\n    margin-top: 20px;\n  }\n\n.search_box{\n  position: relative;\n}\n \nthead .CustomTable_tableheadlight__HuHZw th:first-child, thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  display: math !important;\n}\n\n#spinner{\n  float: right;\n  margin-top: -25px;\n  position: relative;\n  z-index: 1;\n  margin-right: 10px;\n  cursor: pointer;\n  color: $primary-btncolor;\n}\n\n.tbl_sl {\n  min-width: 10px !important;\n}\n\n.tablebtn{\n    width: 70px;\n    padding: 6px;\n    border:  none;\n    background-color: $primary-btncolor;\n    border-radius: 5px;\n    color: $white-color;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 14px;\n\n    &:hover{\n      background-color: $secondary-btncolor;\n    }\n  }\n\ntable{\n    border-collapse:separate !important;\n    border-spacing:0 6px !important;\n  }\n\n// Set border-radius on the top-left and bottom-left of the first table data on the table row\ntd:first-child,\nth:first-child {\n    border-radius: 8px 0 0 8px;\n  }\n\n// Set border-radius on the top-right and bottom-right of the last table data on the table row\ntd:last-child,\nth:last-child {\n    border-radius: 0 8px 8px 0;\n  }\n  \n.tableheaddiv{\n  display: flex;\n}\n  th,td{\n    font-size: 14px;\n     \n     \n  }\n\n  th{\n    padding: 0.8rem 1rem !important;\n  }\n\n  td{\n    padding: .5rem 1rem !important;\n    line-height: 28px;\n  }\n\n\n\n// .order_date{\n//     margin-top: 5px;\n//     font-size: 12px;\n//     color: #898989;\n//     font-weight: normal;\n//   }\n\n.sortbtn{\n  border: none;\n  background: none;\n  color: #6E6E6E;\n  }\n\n.order_date{\n    margin-top: 5px;\n    font-size: 12px;\n    color:#000;\n    font-weight: normal;\n  }\n\nh6{\n  color: #000;\n  }\n\n  \n  .norecord {\n    font-size: 22px;\n    margin-top: 10px;\n    color: #939090;\n  }\n  .norecordsdiv{\n    position: absolute;\n    left: 42%;\n    margin-top: 2%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n.ststus_text {\n  font-size: 14px;\n  font-weight: 600;\n  padding-left: 8px;\n}\n\n.ststus_not_verified {\n  color: #9f9e9d;\n}\n\n.ststus_verified {\n  color: #00ba00;\n}\n\n.ststus_cancelled {\n  color: #ff0000;\n}\n\n.ststus_pending {\n  color: #854d0e;\n}\n\n.ststus_waitlisted {\n  color: #5b21b6;\n}\n\n/* Ticket approval (free registration pending) — matches manager order-management pattern */\n.rowActionsTicketApproval {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 8px;\n}\n\n.approveTicketBtn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1.5px solid #bbf7d0;\n  border-radius: 50%;\n  cursor: pointer;\n  background: #f0fdf4;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.18s ease, border-color 0.18s ease;\n  flex-shrink: 0;\n\n  &:hover:not(:disabled) {\n    background: #bbf7d0;\n    border-color: #86efac;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.rejectTicketBtn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1.5px solid #fecaca;\n  border-radius: 50%;\n  cursor: pointer;\n  background: #fff5f5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.18s ease, border-color 0.18s ease;\n  flex-shrink: 0;\n\n  &:hover:not(:disabled) {\n    background: #fecaca;\n    border-color: #fca5a5;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.ticketApprovalActionSpinner {\n  width: 10px;\n  height: 10px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  animation: ticketApprovalSpin 0.6s linear infinite;\n}\n\n@keyframes ticketApprovalSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ticketConfirmOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n}\n\n.ticketConfirmCard {\n  background: #fff;\n  border-radius: 16px;\n  padding: 32px 28px 24px;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.ticketConfirmIconWrap {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.ticketConfirmIconApprove {\n  background: #dcfce7;\n}\n\n.ticketConfirmIconReject {\n  background: #fee2e2;\n}\n\n.ticketConfirmTitle {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  text-align: center;\n}\n\n.ticketConfirmBody {\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.6;\n  text-align: center;\n  margin: 0;\n\n  strong {\n    color: #111827;\n  }\n}\n\n.ticketWaitlistNote {\n  font-size: 14px;\n  color: #5b21b6;\n  line-height: 1.55;\n  text-align: center;\n  margin: 0 0 10px;\n  padding: 12px 14px;\n  background: #f5f3ff;\n  border-radius: 10px;\n  border: 1px solid #ddd6fe;\n  width: 100%;\n  box-sizing: border-box;\n\n  strong {\n    color: #4c1d95;\n  }\n}\n\n.ticketConfirmActions {\n  display: flex;\n  gap: 10px;\n  margin-top: 8px;\n  width: 100%;\n  justify-content: center;\n}\n\n.ticketConfirmCancelBtn {\n  flex: 1;\n  padding: 10px 16px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: #f9fafb;\n  }\n}\n\n.ticketConfirmApproveBtn {\n  flex: 1;\n  padding: 10px 16px;\n  border: 0;\n  border-radius: 8px;\n  background: #16a34a;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: #15803d;\n  }\n}\n\n.ticketConfirmRejectBtn {\n  flex: 1;\n  padding: 10px 16px;\n  border: 0;\n  border-radius: 8px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: #b91c1c;\n  }\n}\n\n.refund {\n  padding-left: 10px;\n}\n\n.refund button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n}\n\n.refund button:hover {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  outline: none;\n}\n\n.refund button:active {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  outline: none;\n}\n\n.refund button:focus {\n  background-color: transparent;\n  border: none;\n  box-shadow: none !important;\n  outline: none;\n}\n\n\n.refund_tooltip {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.refund_tooltip .tooltiptext {\n  visibility: hidden;\n  width: 120px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  // margin-left: 30px;\n}\n\n.refund_tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\n.search_contain_box {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n.search_contain_box1 {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin:20px 0;\n}\n.tabbtn {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  align-items: center;\n  @media screen and (max-width: 480px) {\n    justify-content: flex-start;\n    gap: 0.5rem;\n  }\n}\n.totalamt{\n  display: flex;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 5px;\nborder: 1px solid #EAEAEA;\ncolor: var(--Font-black, #0B0D0F);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nheight: 42px;\npadding: 10px;\n\n}\n.totalamt span{\n  color: var(--Green, #00C16B);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.totalamt1{\n  display: flex;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 5px;\nborder: 1px solid #EAEAEA;\ncolor: var(--Font-black, #0B0D0F);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nheight: 42px;\npadding: 10px;\n\n}\n.search_contain_box1 h5{\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.eventHeaderRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.viewEventDetailsBtn {\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #CD47F3;\n  background: transparent;\n  border: 1px solid #CD47F3;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n\n  &:hover {\n    background-color: #CD47F3;\n    color: #fff;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(205, 71, 243, 0.3);\n  }\n}\n.totalamt1 ul{\n  list-style: none;\n  display: flex;\n  gap: 10px;\n  padding: 0 !important;\n  margin: 0;\n  \n}\n.totalamt1 span{\ncolor: var(--Primary, #FD9800);\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.Total_count {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-right: 15px;\n  justify-content: flex-end;\n}\n\n.Total_seat_count {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.Total_seat_count span {\n  background: #07bf0d;\n  padding: 5px;\n  border-radius: 3px;\n  color: #fff;\n}\n\n.user_tb_hd {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n\n  .info_contain {\n    background-color: #D1ECF1;\n    border: solid 1px #BEE5EB;\n    border-radius: 4px;\n    padding: 10px 20px;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    flex-wrap: wrap;\n    min-height: 45px;\n    height: auto;\n    flex: 1 1 auto;\n\n    .info_content {\n      display: flex;\n      gap: 8px;\n      align-items: center;\n      flex-wrap: wrap;\n\n      @media screen and (max-width: 767px) {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 4px;\n      }\n    }\n\n    p {\n      margin: 0;\n      color: #0C5460;\n      font-size: 15px;\n      font-weight: 500;\n    }\n\n    button {\n      height: unset;\n      background-color: transparent;\n      border: none;\n      padding: 0;\n      font-size: 15px;\n      font-weight: 700;\n      color: #0C5460;\n      text-decoration: underline;\n      white-space: nowrap;\n\n      &:hover {\n        color: #1492a7;\n      }\n      &:focus {\n        outline: none;\n        border: none;\n        box-shadow: none;\n      }\n    }\n\n    @media screen and (max-width: 767px) {\n      width: 100%;\n      padding: 12px 16px;\n    }\n  }\n}\n\n.sectionright{\n  float: right;\n  display: flex;\n  gap: 30px;\n\n  #dropdown{\n    margin:0px 10px 10px 10px;\n  }\n  #dropdown button{\n      background-color:$primary-btncolor;\n      border-radius:5px;\n      border:none;\n      box-shadow:none;\n      font-size:14px;\n      min-width: 140px;\n      min-height: 44px;\n  }\n  a{\n      font-size:14px;\n       \n  }\n  #del_icon{\n    font-size: 12px;\n    margin-left:5px;\n}\n\n}\n.tdactive{\n  padding: 8px 10px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n  margin-top: 8px;\n  background: rgba(0, 193, 107, 0.20);\n  color: #00C16B;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: uppercase;\n  margin-top: 8px;\n\n}\n\n.tdinactive{\n  padding: 8px 10px;\njustify-content: center;\nalign-items: center;\nborder-radius: 100px;\nbackground: rgba(255, 0, 0, 0.20);\ncolor: #F00;\ntext-align: center;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\ntext-transform: uppercase;\nmargin-top: 8px;\n}\n\n.tdyellowbg{\n  padding: 8px 10px;\njustify-content: center;\nalign-items: center;\nborder-radius: 100px;\nbackground: rgba(253, 152, 0, 0.20);\ncolor: #FD9800;\ntext-align: center;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\ntext-transform: uppercase;\nmargin-top: 8px;\n}\n\n.arrowback{\n  margin-bottom: 0px;\n  cursor: pointer;\n}\n\n.searchcontainer {\n  display:flex;\n  justify-content: end;\n}\n\n.searchcontainer_inner {\n    display: flex;\n    justify-content: end;\n    flex-direction: column;\n}\n\n.attent_flex_contain {\n  display: block;\n}\n\n.attent_flex_contain h5 {\n  margin: 20px 0px;\n}\n\n.pay_btn {\n  margin-right: 10px;\n}\n\n.count_contain {\n  display: flex;\n  flex-direction: column;\n  .totalamt1 {\n    height: auto;\n  }\n}\n\n\ntr:nth-child(even) {\n  background-color: #fcfcfc;\n}\n\n.onboardsty {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n/* ── Tablet & below (≤1230px) ── */\n@media screen and (max-width: 1230px) {\n  .onboardsty {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .onboardsty button {\n    width: 100%;\n  }\n  .user_tb_hd {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n}\n\n/* ── ≤1250px: stat/search containers stack ── */\n@media only screen and (max-width: 1250px) {\n  .search_contain_box1 {\n    flex-direction: column;\n  }\n}\n\n/* ── ≤1350px: inner search container ── */\n@media only screen and (max-width: 1350px) {\n  .searchcontainer_inner {\n    display: unset;\n  }\n}\n\n/* ── Tablet (≤992px) ── */\n@media only screen and (max-width: 992px) {\n  .search_contain_box {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .search_contain_box input {\n    min-width: 100% !important;\n    width: 100% !important;\n  }\n  .tabbtn {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  .tabbtn button,\n  .tabbtn a {\n    flex: 1 1 auto;\n    min-width: 120px;\n    justify-content: center;\n    white-space: nowrap;\n  }\n  .Total_count {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: baseline;\n    margin-right: 0;\n  }\n  .Total_seat_count {\n    font-size: 14px;\n  }\n}\n\n/* ── Mobile (≤768px) ── */\n@media only screen and (max-width: 768px) {\n  .attent_flex_contain h5 {\n    margin: 14px 0;\n    font-size: 16px;\n  }\n  .search_contain_box1 {\n    flex-direction: column;\n    gap: 12px;\n    margin: 12px 0;\n  }\n  .search_contain_box {\n    flex-direction: column;\n    align-items: stretch;\n    margin-bottom: 16px;\n    gap: 10px;\n  }\n  .search_contain_box input {\n    min-width: 100% !important;\n    width: 100% !important;\n  }\n  .search_contain {\n    width: 100%;\n  }\n  .tabbtn {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 8px;\n    align-items: stretch;\n  }\n  .tabbtn button,\n  .tabbtn a {\n    width: 100% !important;\n    min-width: unset !important;\n    justify-content: center;\n  }\n  .export_btn {\n    min-width: unset !important;\n  }\n  .count_contain {\n    gap: 12px;\n  }\n  .sectionright {\n    float: none;\n    gap: 8px;\n    flex-direction: column;\n  }\n  .user_tb_hd {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .info_contain {\n    height: auto !important;\n    flex-direction: column;\n    padding: 12px 16px !important;\n  }\n}\n\n/* ── Small mobile (≤600px) ── */\n@media only screen and (max-width: 600px) {\n  #dashboardcont2 {\n    width: $dashwidth;\n    left: $dashleft;\n    position: relative;\n    padding: 10px;\n  }\n  .totalamt1 ul {\n    flex-direction: column;\n  }\n  .tabbtn {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Extra small (≤480px) ── */\n@media only screen and (max-width: 480px) {\n  .searchcontainer_inner {\n    align-items: stretch;\n  }\n  .search_contain_box1 {\n    align-items: stretch;\n  }\n  .arrowback {\n    font-size: 14px;\n  }\n  .count_box_contain {\n    padding: 14px;\n  }\n}\n\n\n.count_box_contain {\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 24px 30px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  @media screen and (max-width: 992px) {\n    gap: 20px;\n    padding: 20px;\n  }\n  @media screen and (max-width: 480px) {\n    padding: 14px;\n    gap: 16px;\n  }\n\n  ul {\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 16px;\n\n    li {\n      list-style: none;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      flex: 1 1 calc(20% - 16px);\n      min-width: 90px;\n\n      @media screen and (max-width: 1024px) {\n        flex: 1 1 calc(33.33% - 16px);\n      }\n      @media screen and (max-width: 576px) {\n        flex: 1 1 calc(50% - 12px);\n      }\n      @media screen and (max-width: 360px) {\n        flex: 1 1 100%;\n      }\n\n      .count_text {\n        font-size: 13px;\n        font-weight: 600;\n        color: #727272;\n\n        @media screen and (min-width: 1245px) {\n          font-size: 15px;\n        }\n      }\n\n      .count_num {\n        font-size: 18px;\n        font-weight: 700;\n        color: #131F43;\n\n        @media screen and (min-width: 1245px) {\n          font-size: 22px;\n        }\n        @media screen and (max-width: 480px) {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n}\n\n.export_btn {\n  font-size: 15px;\n  font-weight: 600;\n  color: #131F43 !important;\n  border: solid 1px #131F43 !important;\n  border-radius: 5px;\n  background-color: transparent !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 44px;\n  padding: 10px 20px !important;\n  white-space: nowrap;\n  min-width: unset;\n}\n\n.export_btn svg {\n  fill: #131F43;\n  flex-shrink: 0;\n}\n\n.export_btn:hover {\n  color: #fff !important;\n  border-color: #131F43 !important;\n  background-color: #131F43 !important;\n}\n\n.export_btn:hover svg {\n  fill: #fff;\n}\n\n.table_attendee {\n  th {\n    @media screen and (max-width: 1200px) {\n      min-width: 140px;\n    }\n    @media screen and (max-width: 998px) {\n      min-width: 150px;\n    }\n    @media screen and (max-width: 480px) {\n      min-width: 100px;\n      font-size: 12px;\n      padding: 0.5rem 0.75rem !important;\n    }\n  }\n  td {\n    @media screen and (max-width: 480px) {\n      font-size: 12px;\n      padding: 0.4rem 0.75rem !important;\n    }\n  }\n}\n\n// Ensure table scrolls horizontally on small screens\n@media screen and (max-width: 768px) {\n  :global(.table-responsive) {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n","/* \nscss\n */\n $font-regular: 400;\n $font-medium: 500;\n $font-semiBold: 600;\n $font-bold: 700;\n $font-extraBold: 800;\n $font-black: 900;\n \n $mainBg: #F5F6FA;\n $primary-color: #131F43;\n $icon-bgcolor: #F6F6F6;\n $text-graycolor: #727272;\n $cardIcon1-bg: #F3F4F8;\n $cardIcon1-darkbg: #30231a;\n $cardIcon1-darkbg-icon: #9d785f;\n $cardIcon2-bg: #FAF4FB;\n $cardIcon2-darkbg: #13252a;\n $cardIcon2-darkbg-icon: #3b606a;\n $cardIcon3-bg: #FAF7F3;\n $cardIcon3-darkbg: #2c1a27;\n $cardIcon3-darkbg-icon: #6c4863;\n $cardIcon4-bg: #F5F9FC;\n $cardIcon4-darkbg: #241d3e;\n $cardIcon4-darkbg-icon: #5f538b;\n $cardIcon2-color: #AC44BB;\n $cardIcon3-color: #D69A5F;\n $cardIcon4-color: #176CA5;\n $green-color: #38A169;\n $darkGreen-color: #207a4a;\n $placeholder-color: #666666;\n $profile-dark-text: #181818;\n $heading : #0B0D0F;\n $light-gray : #999999;\n $menu_icon : #CBCBCB;\n $red-color : #F94747;\n $red-hover : #960101;\n $dark-active-blue : #3b82f6;\n $dark-light-blue : #92afd3;\n $addBtn-dark-blue : #3b82f6;\n $addBtn-dark-blue-hover : #2563eb;\n $backBtn-dark : #3b82f633;\n \n \n \n $darkTheme_blue : #132337;\n $darkTheme_darkBlue : #0f1824;\n $darkTheme_selectBlue : #1c2e45;\n $darkTheme_updateBtn : #0a2574;\n \n /* \n Body Theme Color\n  */\n $lightthemecolor: #f3f6f9;\n $darkthemecolor: #151521;\n \n $white-color: #fff;\n $black-color: #1d1d1d;\n $fullBlack-color: #1d1d1d;\n $lightthemetext: #60677e;\n \n /* \n Dark Theme Colors\n */\n $primarydark-color: #132337;\n \n /* \n Button Theme\n */\n $primary-btncolor: #131F43;\n $secondary-btncolor: rgba(37, 105, 109, 0.864);\n \n $tableheadlightbg: #e9eaf0;\n \n \n /* \n Max Dashboard scss\n */\n $dashboardwidth: calc(100% - 320px);\n $dashboardposition: absolute;\n $dashboardleft: 290px;\n $dashboardpadding: 30px;\n \n /* \n Min Dashboard scss\n */\n $dashwidth: calc(100% - 50px);\n $dashleft: 50px;\n \n /* \n Max Dashboard scss\n */\n \n .dashboard {\n   width: $dashboardwidth;\n   position: relative;\n   left: $dashboardleft;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   min-height: auto !important;\n   background-color: $mainBg;\n   overflow-y: auto;\n }\n \n .dashboardContain {\n   width: calc(100% - 320px);\n   background-Color: $mainBg;\n   border-radius: 8px;\n }\n \n .bodythemedark .dashboardContain,\n .bodythemedark .dashboard,\n .bodythemedark .cont2 {\n   background-Color: $darkTheme_darkBlue;\n }\n \n .top_header .top_header_inner {\n   background-color: transparent;\n   height: auto;\n   overflow-y: unset;\n }\n \n /* \n Min Dashboard scss\n */\n \n .cont2 {\n   width: $dashwidth;\n   left: $dashleft;\n   position: relative;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   background: $mainBg;\n   /*height: calc(100vh - 160px);*/\n   height: 100%;\n   min-height: auto !important;\n   overflow-y: auto;\n   /* \n background-Color: $dashboardbackgroundColor;\n   padding-bottom: 8%;\n */\n }\n \n .subLink svg {\n   position: relative;\n   top: -2px;\n   left: -7px;\n }\n \n \n \n .cst_vendr input {\n   min-height: 35px !important;\n }\n \n .cst_vendr .form-control {\n   background-color: #f5f6fa;\n   border: none;\n }\n \n \n .footer {\n   height: 70px;\n }\n \n body {\n   background-color: $white-color;\n }\n \n /* \n THEME CHANGE\n */\n .bodythemelight {\n   background-color: $white-color;\n   padding-top: 90px;\n }\n \n .bodythemedark {\n   background-color: $darkTheme_blue;\n   padding-top: 90px;\n }\n \n /* \n Header Navbar Theme\n */\n .headerthemelight {\n   background-color: $white-color;\n }\n \n .headerthemedark {\n   background-color: $darkTheme_blue;\n }\n \n .top_header {\n   min-height: 90px;\n   display: flex;\n   align-items: center;\n   position: fixed;\n   width: 100%;\n   z-index: 2;\n   top: 0;\n }\n \n /* \n LEFT MENU THEME CHANGE\n */\n .menuthemelight {\n   background-color: $white-color;\n }\n \n .menuthemedark {\n   background-color: $darkTheme_blue;\n }\n \n /* \n LEFT MENU LINKS THEME CHANGE\n */\n .menulinklight span {\n   color: $placeholder-color !important;\n }\n \n .menulinklight a {\n   color: $menu_icon !important;\n }\n \n .menulinklight:hover span,\n .menulinklight:hover a {\n   color: $white-color !important;\n }\n \n .menulinkdarkSelected {\n   background-color: $darkTheme_selectBlue;\n   color: $dark-active-blue;\n }\n \n .menuthemelight .menulinklightSelected {\n   /*background-color: $lightthemecolor;*/\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinkdark {\n   color: $dark-light-blue !important;\n }\n \n .menulinklight:hover {\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinklight .sub_arrow svg path {\n   stroke: $menu_icon !important;\n }\n \n .menulinklight:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinkdark .sub_arrow svg path {\n   stroke: $dark-light-blue !important;\n }\n \n .menulinkdark:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinklight:hover svg path,\n .menulinklightSelected svg path {\n   fill: #fff !important;\n }\n \n .menulinkdark:hover {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n /* \n BODY HEADERS\n */\n .headinglight {\n   color: $lightthemetext;\n }\n \n .headingdark {\n   color: $lightthemetext;\n }\n \n /* \n SEARCH BOX THEME COLOR\n */\n .searchboxlight {\n   background-color: $white-color;\n   border: none;\n }\n \n .searchboxdark {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n   border: none;\n }\n \n .searchboxdark::placeholder {\n   color: $lightthemetext;\n }\n \n /* \n CUSTOM TABLE THEME COLOR\n */\n .tableheadlight {\n   background-color: $primary-color;\n   border-radius: 5px 5px 0px 0px;\n }\n \n .tableheadlight th {\n   color: $white-color;\n }\n \n thead .tableheadlight th:first-child,\n thead .tableheaddark th:first-child {\n   border-radius: 5px 0 0 0px;\n }\n \n thead .tableheadlight th:last-child,\n thead .tableheaddark th:last-child {\n   border-radius: 0 5px 0px 0;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n td:last-child {\n   border-radius: 0px;\n }\n \n table.table.table-borderless {\n   border-collapse: separate !important;\n   border-spacing: 0 0px !important;\n }\n \n .tableheaddark {\n   background-color: $primarydark-color;\n   color: $white-color;\n }\n \n .table-borderless tr:nth-child(even) {\n   background-color: #F9FAFB;\n }\n \n .table-borderless .left-section {\n   padding-top: 10px;\n }\n \n .tablebodylight td,\n .tablebodydark td {\n   padding: 0.5rem 1rem !important;\n   line-height: 45px;\n }\n \n .tablebodylight {\n   background-color: $white-color;\n \n   &:hover {\n     background-color: $white-color;\n     cursor: auto;\n   }\n }\n \n .tablebodydark {\n   /* background-color: $primarydark-color; */\n   color: $lightthemetext;\n \n   &:hover {\n     background-color: rgba(33, 150, 243, 0.1);\n     cursor: pointer;\n   }\n }\n \n /* \n PAGINATION THEME COLOR\n */\n .paginationlight {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n .paginationdark {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n /* \n SETTING FORM THEME COLOR\n */\n .formthemelight {\n   background-color: $white-color;\n   color: $black-color !important;\n   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n }\n \n .formthemedark {\n   background-color: $primarydark-color;\n   color: $lightthemetext !important;\n   font-size: 14px;\n \n   ::placeholder {\n     color: $lightthemetext;\n   }\n }\n \n \n /* \n VIEW FORM DETAILS BOX THEME COLOR\n */\n .viewformlight {\n   background-color: $lightthemecolor;\n }\n \n .permissionboxlight {\n   background-color: #f8f9fa;\n   border: 1px solid #dee2e6;\n }\n \n .permissionboxdark {\n   background-color: $darkTheme_darkBlue;\n   border: solid 1px #242434;\n }\n \n .errormsgclr {\n   color: red;\n   font-size: 14px;\n   margin-top: 5px;\n }\n \n /* \n Graph theme\n */\n .graphclrlight {\n   background-color: $white-color;\n }\n \n .graphclrdark {\n   background-color: $primarydark-color;\n }\n \n \n /* \n Counter theme\n */\n #card1bglight {\n   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card1bgdark {\n   background: #392f28;\n }\n \n #card2bglight {\n   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card2bgdark {\n   background: #1c3238;\n }\n \n #card3bglight {\n   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card3bgdark {\n   background: #3a2434;\n }\n \n #card4bglight {\n   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card4bgdark {\n   background: #2f264f;\n }\n \n #card1bgdark a,\n #card1bgdark p,\n #card2bgdark a,\n #card2bgdark p,\n #card3bgdark a,\n #card3bgdark p,\n #card4bgdark a,\n #card4bgdark p {\n   color: $white-color;\n }\n \n /* \n Action button theme\n */\n .actionbtnlight {\n   color: #46475bde;\n }\n \n .actionbtndark {\n   color: $lightthemetext;\n }\n \n \n /* \n profile dropdowntheme\n */\n .profiledropdownlight {\n   background-color: #fff;\n }\n \n .profiledropdowndark {\n   background-color: #151521;\n }\n \n .settingsection #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .profile_conatiner {\n   border-radius: 5px !important;\n }\n \n .bodythemedark .ag-theme-alpine .ag-row {\n   background: #000 !important;\n }\n \n .bodythemedark .formbtn {\n   background-color: $addBtn-dark-blue;\n }\n \n .bodythemedark .formbtn:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .bodythemedark .resetbtn {\n   color: $white-color;\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n }\n \n \n .headingdark span {\n   background-color: $darkTheme_blue;\n }\n \n .resetbtn {\n   font-size: 16px !important;\n   font-weight: $font-semiBold !important;\n   border-radius: 5px !important;\n   background-color: transparent !important;\n   border: solid 1px $primary-color !important;\n   color: $primary-color !important;\n   min-width: 113px !important;\n }\n \n .resetbtn:hover,\n .resetbtn:active,\n .resetbtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n }\n \n .addBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n\n  .addDltBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n \n .addbtnlight {\n   background-color: $green-color;\n }\n \n .addbtndark {\n   background-color: $addBtn-dark-blue;\n }\n \n .addbtndark:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .formthemedark label {\n   color: $dark-light-blue;\n }\n \n \n .addBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: 2px;\n }\n \n .addBtn:hover {\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n }\n \n .cust_addBtn.addBtn svg {\n   top: 2px;\n }\n \n \n .deleteBtn {\n   min-width: 130px;\n   height: 50px;\n   background-color: $red-color;\n   color: $white-color;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n   border: none;\n }\n \n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .deleteBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: -2px;\n }\n \n .deleteBtn:hover,\n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color;\n   color: $white-color;\n   border: none;\n }\n \n .confirmBtn {\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  background-color: $primary-color !important;\n }\n\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .confirmBtn:hover,\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $darkTheme_darkBlue !important;\n }\n \n .confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n \n \n \n .delPopContainer .modal-body {\n   padding: 35px;\n   text-align: center;\n }\n \n .delPopContainer .delet_icon {\n   margin-bottom: 11px;\n }\n \n .delPopContainer p {\n   color: #131f43;\n   font-size: 14px;\n   font-weight: 700;\n   padding: 0 20px;\n }\n \n .arrowback svg {\n   fill: #000;\n }\n \n .bodythemedark .arrowback {\n   background-color: $backBtn-dark;\n   color: $dark-active-blue;\n }\n \n .bodythemedark .arrowback svg {\n   fill: $dark-active-blue;\n }\n \n .bodythemedark .drpdwn_btn {\n   background-color: $darkTheme_blue;\n }\n \n .bodythemedark .empname {\n   color: $dark-light-blue !important;\n }\n \n .bodythemedark .navitemli a {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingsgeneral,\n .bodythemedark .tabnavli a.settingslinks:hover {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingslinks {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a,\n .headerthemedark .dropdown_menu_contain .dropdown_item,\n .headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a:hover,\n .headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n }\n \n .dropdown_item:active {\n   background-color: $mainBg;\n }\n \n .profile_arrrow_dwn {\n   stroke: $darkTheme_blue;\n }\n \n .headerthemedark .profile_arrrow_dwn {\n   stroke: $white-color;\n }\n \n .dateinputbox1 input,\n .dateinputbox1 span {\n   color: $white-color !important;\n }\n \n /* LOGOUT MODAL */\n .modalStyleLight {}\n \n .modalStyleDark {}\n \n .delPopContainer .modal-content {\n   border-radius: 10px;\n   min-width: 399px;\n }\n \n .larg_model .modal-dialog {\n   max-width: 100% !important;\n }\n \n .larg_model .modal-content {\n   /* display: inline-block; */\n   height: 100%;\n   max-width: 900px;\n   margin: auto;\n   border-radius: 54px !important;\n   background: #FFF;\n   padding: 53px 53px 23px;\n }\n \n .larg_model .modal-header {\n   padding: 0px 0px 23px;\n   border-bottom: 1px dashed #D4D9EE;\n   display: block;\n }\n \n body .btn-primary:hover {\n   background-color: transparent;\n   border-color: #131F43;\n   color: #131F43;\n   fill: #131F43;\n   border: 1px solid;\n }\n \n .form-select {\n   display: block;\n   width: 100%;\n   padding: .375rem 2.25rem .375rem .75rem;\n   -moz-padding-start: calc(0.75rem - 3px);\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #212529;\n   background-color: #fff;\n   background-image: url(../../assets/select_arow.svg) !important;\n }\n \n thead .CustomTable_tableheadlight__HuHZw th:first-child,\n thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n   border-radius: 5px 0 0 0px;\n   display: math;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n @media only screen and (max-width: 1200px) {\n   .tableheadlight th {\n     min-width: 170px;\n   }\n }\n \n @media only screen and (max-width: 1024px) {\n   .dashboard {\n     width: calc(100% - 50px) !important;\n     left: 50px !important;\n     padding: 10px 10px !important;\n     overflow-x: hidden;\n   }\n \n   .cont2 {\n     height: calc(100vh - 160px);\n     overflow-y: auto;\n   }\n }\n \n @media only screen and (max-width: 998px) {\n   /* #dashboardcont2{\n     height: auto !important;\n   }*/\n   /*.tableheadlight th {\n     min-width: 200px !important;\n   }*/\n }\n \n @media only screen and (max-width: 767px) {\n   .sectionright {\n     float: unset !important;\n   }\n .formthemelight {\n   padding: 10px 0!important;\n   box-shadow: none !important;\n }\n   .dashboard {\n     padding: 10px 10px !important;\n   }\n }\n \n @media only screen and (max-width: 600px) {\n   .cont2 {\n     width: $dashwidth !important;\n     left: $dashleft !important;\n     position: relative !important;\n     padding: 10px 10px 15px !important;\n   }\n \n   .bodythemelight,\n   .bodythemedark {\n     padding-top: 110px;\n   }\n \n   .delPopContainer .modal-content {\n     min-width: 100%;\n   }\n \n   .delPopContainer .modal-body {\n     padding: 15px;\n   }\n \n   .larg_model .modal-content {\n     border-radius: 20px !important;\n     padding: 22px;\n   }\n }\n \n @media (min-width: 576px) {\n   .exer_modal_contain .modal-dialog {\n     max-width: 1055px;\n   }\n \n   .delPopContainer .modal-dialog {\n     max-width: 350px;\n   }\n \n   /*.tableheadlight th {\n     min-width: 200px;\n   }*/\n }\n \n /* vk new changes */\n .active_show_outer {\n \n h2 {\n   color: var(--Font-black, #0B0D0F);\n   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n   font-size: 22px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n }\n \n   .active_show_inner {\n     width: 100%;\n     display: block;\n \n     .act_box_img {\n       margin-bottom: 12px;\n       min-height: 400px;\n       object-fit: cover;\n       overflow: hidden;\n       height: 400px;\n       max-height: 400px;\n       @media (max-width: 767px) {\n         min-height: 300px;\n         height: 300px;\n         max-height: 300px;\n       }\n       img {\n         max-height: 400px;\n         /* align-self: stretch; */\n         width: 100%;\n         height: 100%;\n         border-radius: 12px;\n         object-fit: cover;\n       }\n     }\n \n     .act_box_cnt {\n       width: 100%;\n       display: block;\n svg{\n  flex-shrink: 0;\n }\n       .act_box_bdg {\n         width: 100%;\n         margin-bottom: 12px;\n \n         span {\n           background: url(../../assets/ongoing.png) right top no-repeat;\n           width: 111px;\n           display: block;\n           height: 34px;\n           color: var(--White, #FFF);\n           font-size: 18px;\n           font-style: normal;\n           font-weight: 500;\n           padding: 3px 8px;\n         }\n \n         .sold {\n           background: url(../../assets/sold.png) right top no-repeat !important;\n         }\n \n       }\n \n       h3 {\n         color: var(--Secondary, #132941);\n         font-size: 18px;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 26.304px;\n         margin: 0;\n       }\n \n       p {\n         display: flex;\n         align-items: center;\n         gap: 10px;\n         margin-bottom: 5px;\n \n         span {\n           color: var(--Light-1, #736B66);\n           font-size: 14px;\n           font-style: normal;\n           font-weight: 500;\n           line-height: 26.304px;\n         }\n       }\n     }\n   }\n }\n \n /* vk new changes */\n .attent_details {\n   .attent_details_inner {\n     display: flex;\n     gap: 61px;\n     padding: 20px;\n     border-radius: 5px;\n     background: #FFF;\n     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n     align-items: center;\n \n     @media (max-width: 576px) {\n       display: block !important;\n     }\n \n     @media (max-width: 992px) {\n       display: flex;\n       gap: 20px;\n       align-items: start;\n     }\n \n     .attent_details_inner_l {\n       img {\n         width: 187px;\n         height: 207px;\n         flex-shrink: 0;\n         object-fit: contain;\n         @media screen and (max-width:767px) {\n          object-fit: contain;\n          width: auto;\n         }\n       }\n     }\n \n     .attent_details_inner_r {\n       flex: 1;\n \n       .attent_details_row {\n         display: flex;\n         gap: 20px;\n         margin-bottom: 28px;\n \n         @media (max-width: 992px) {\n           margin-bottom: 0px;\n           display: inline-block;\n           width: 100%;\n         }\n \n         .attent_details_row_box {\n           flex: 1;\n           width: 22%;\n \n           @media (max-width: 576px) {\n             margin: 15px 0px 10px !important;\n             width: 100% !important;\n           }\n \n           @media (max-width: 992px) {\n             margin-bottom: 15px;\n             float: left;\n             margin-right: 0;\n             width: 50%;\n             padding-right: 10px;\n           }\n \n           p {\n             margin-bottom: 10px;\n             color: #727272;\n             font-size: 13px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n           }\n \n           h5 {\n             color: #131F43;\n             font-size: 16px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n             word-wrap: break-word;\n           }\n         }\n       }\n \n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n     }\n   }\n }\n .showbox_sec {\n   display: grid;\n   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n   gap: 20px;\n   align-items: stretch;\n   width: 100%;\n   @media screen and (max-width: 500px) {\n     grid-template-columns: 1fr;\n   }\n }\n .show_box_main {\n   margin: 10px 0px;\n   width: 100%;\n\n   .show_box {\n     min-height: 600px;\n     width: 100%;\n     margin-bottom: 0;\n     cursor: pointer;\n     display: flex;\n     flex-direction: column;\n     box-sizing: border-box;\n\n     @media (max-width: 767px) {\n       min-height: 500px;\n     }\n\n     .active_show_inner {\n       display: flex;\n       flex-direction: column;\n       flex: 1;\n       min-height: 0;\n     }\n\n     .act_box_img {\n       flex-shrink: 0;\n     }\n\n     .act_box_cnt {\n       flex: 1;\n       display: flex;\n       flex-direction: column;\n       min-height: 0;\n     }\n\n     img {\n       max-height: 400px;\n       height: 100%;\n       width: 100%;\n       object-fit: cover;\n\n       @media (max-width: 767px) {\n         max-height: 300px !important;\n       }\n     }\n\n     &:last-child {\n       margin-right: 0;\n     }\n   }\n \n   .no_show_box {\n     width: 350px;\n     margin: 0 auto 20px;\n     display: block;\n   \n     @media (max-width: 767px) {\n       width: 250px !important;\n     }\n   \n     img {\n       max-height: 450px;\n       height: 100%;\n       width: 100%;\n   \n       @media (max-width: 767px) {\n         max-height: 350px !important;\n       }\n     }\n     h6 {\n       color: #000;\n       text-align: center;\n       font-size: 26px;\n       font-style: normal;\n       font-weight: 700;\n       line-height: normal;\n       margin-top: 20px;\n       @media only screen and (max-width: 600px) {\n         font-size: 20px;\n       }\n     }\n   }\n   \n \n }\n \n .attent_flex {\n   justify-content: space-between !important;\n   gap: 30px;\n   align-items: center;\n \n   h5 {\n     font-size: 22px;\n     font-style: normal;\n     font-weight: 700;\n   }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `AttendeeCustomTable_dashboard__ar5py`,
	"dashboardContain": `AttendeeCustomTable_dashboardContain__9Ea-6`,
	"bodythemedark": `AttendeeCustomTable_bodythemedark__aBYIU`,
	"cont2": `AttendeeCustomTable_cont2__vnuPv`,
	"top_header": `AttendeeCustomTable_top_header__fPV4a`,
	"top_header_inner": `AttendeeCustomTable_top_header_inner__7ErW4`,
	"subLink": `AttendeeCustomTable_subLink__zGuKZ`,
	"cst_vendr": `AttendeeCustomTable_cst_vendr__odxfK`,
	"form-control": `AttendeeCustomTable_form-control__zbaGf`,
	"footer": `AttendeeCustomTable_footer__2XRLu`,
	"bodythemelight": `AttendeeCustomTable_bodythemelight__Fycx+`,
	"headerthemelight": `AttendeeCustomTable_headerthemelight__Eyjk7`,
	"headerthemedark": `AttendeeCustomTable_headerthemedark__rrIXM`,
	"menuthemelight": `AttendeeCustomTable_menuthemelight__wQ+6e`,
	"menuthemedark": `AttendeeCustomTable_menuthemedark__+bzgb`,
	"menulinklight": `AttendeeCustomTable_menulinklight__g7BfP`,
	"menulinkdarkSelected": `AttendeeCustomTable_menulinkdarkSelected__tRIFG`,
	"menulinklightSelected": `AttendeeCustomTable_menulinklightSelected__UnJpq`,
	"menulinkdark": `AttendeeCustomTable_menulinkdark__+srHQ`,
	"sub_arrow": `AttendeeCustomTable_sub_arrow__h6ARI`,
	"headinglight": `AttendeeCustomTable_headinglight__2yuFe`,
	"headingdark": `AttendeeCustomTable_headingdark__ghMSk`,
	"searchboxlight": `AttendeeCustomTable_searchboxlight__T8h28`,
	"searchboxdark": `AttendeeCustomTable_searchboxdark__Fc-G5`,
	"tableheadlight": `AttendeeCustomTable_tableheadlight__KxfZg`,
	"tableheaddark": `AttendeeCustomTable_tableheaddark__wIhca`,
	"table": `AttendeeCustomTable_table__5S-F2`,
	"table-borderless": `AttendeeCustomTable_table-borderless__2mPFq`,
	"left-section": `AttendeeCustomTable_left-section__oyvL0`,
	"tablebodylight": `AttendeeCustomTable_tablebodylight__pdgcp`,
	"tablebodydark": `AttendeeCustomTable_tablebodydark__qAncM`,
	"paginationlight": `AttendeeCustomTable_paginationlight__40Aii`,
	"paginationdark": `AttendeeCustomTable_paginationdark__4R6bb`,
	"formthemelight": `AttendeeCustomTable_formthemelight__TKLpc`,
	"formthemedark": `AttendeeCustomTable_formthemedark__lm8-U`,
	"viewformlight": `AttendeeCustomTable_viewformlight__evfnU`,
	"permissionboxlight": `AttendeeCustomTable_permissionboxlight__hZBAe`,
	"permissionboxdark": `AttendeeCustomTable_permissionboxdark__B9ap7`,
	"errormsgclr": `AttendeeCustomTable_errormsgclr__fHGm5`,
	"graphclrlight": `AttendeeCustomTable_graphclrlight__f3TwN`,
	"graphclrdark": `AttendeeCustomTable_graphclrdark__C5z2h`,
	"card1bglight": `AttendeeCustomTable_card1bglight__9LW9u`,
	"card1bgdark": `AttendeeCustomTable_card1bgdark__dRgRB`,
	"card2bglight": `AttendeeCustomTable_card2bglight__34AQ0`,
	"card2bgdark": `AttendeeCustomTable_card2bgdark__kSbyi`,
	"card3bglight": `AttendeeCustomTable_card3bglight__20AQ5`,
	"card3bgdark": `AttendeeCustomTable_card3bgdark__PvhS2`,
	"card4bglight": `AttendeeCustomTable_card4bglight__iBmgK`,
	"card4bgdark": `AttendeeCustomTable_card4bgdark__A-nK2`,
	"actionbtnlight": `AttendeeCustomTable_actionbtnlight__oVVbZ`,
	"actionbtndark": `AttendeeCustomTable_actionbtndark__b6SuU`,
	"profiledropdownlight": `AttendeeCustomTable_profiledropdownlight__Esary`,
	"profiledropdowndark": `AttendeeCustomTable_profiledropdowndark__ZKBNt`,
	"settingsection": `AttendeeCustomTable_settingsection__Bfq+v`,
	"addform": `AttendeeCustomTable_addform__SXsM9`,
	"savebtn": `AttendeeCustomTable_savebtn__6wLWt`,
	"profile_conatiner": `AttendeeCustomTable_profile_conatiner__KnlOE`,
	"ag-theme-alpine": `AttendeeCustomTable_ag-theme-alpine__ZXAFI`,
	"ag-row": `AttendeeCustomTable_ag-row__OHnLq`,
	"formbtn": `AttendeeCustomTable_formbtn__aCSGq`,
	"resetbtn": `AttendeeCustomTable_resetbtn__ljCy-`,
	"addBtn": `AttendeeCustomTable_addBtn__YJnoY`,
	"addDltBtn": `AttendeeCustomTable_addDltBtn__7aHOO`,
	"addbtnlight": `AttendeeCustomTable_addbtnlight__948dV`,
	"addbtndark": `AttendeeCustomTable_addbtndark__26l-y`,
	"cust_addBtn": `AttendeeCustomTable_cust_addBtn__rVSnr`,
	"deleteBtn": `AttendeeCustomTable_deleteBtn__KsvX9`,
	"confirmBtn": `AttendeeCustomTable_confirmBtn__P+GTu`,
	"delPopContainer": `AttendeeCustomTable_delPopContainer__xhcoA`,
	"modal-body": `AttendeeCustomTable_modal-body__Cz2Ep`,
	"delet_icon": `AttendeeCustomTable_delet_icon__P4-5Z`,
	"arrowback": `AttendeeCustomTable_arrowback__jXmv0`,
	"drpdwn_btn": `AttendeeCustomTable_drpdwn_btn__0xF-4`,
	"empname": `AttendeeCustomTable_empname__+7jN8`,
	"navitemli": `AttendeeCustomTable_navitemli__TqhdC`,
	"tabnavli": `AttendeeCustomTable_tabnavli__b7GqZ`,
	"settingsgeneral": `AttendeeCustomTable_settingsgeneral__SwlNi`,
	"settingslinks": `AttendeeCustomTable_settingslinks__Ag6yJ`,
	"dropdown_menu_contain": `AttendeeCustomTable_dropdown_menu_contain__0x2Mm`,
	"dropdown_item": `AttendeeCustomTable_dropdown_item__ePkjb`,
	"profile_arrrow_dwn": `AttendeeCustomTable_profile_arrrow_dwn__X24e-`,
	"dateinputbox1": `AttendeeCustomTable_dateinputbox1__H9kdw`,
	"modal-content": `AttendeeCustomTable_modal-content__J1sSs`,
	"larg_model": `AttendeeCustomTable_larg_model__UJOhp`,
	"modal-dialog": `AttendeeCustomTable_modal-dialog__lQ247`,
	"modal-header": `AttendeeCustomTable_modal-header__yQJ5J`,
	"btn-primary": `AttendeeCustomTable_btn-primary__7phB5`,
	"form-select": `AttendeeCustomTable_form-select__b+156`,
	"CustomTable_tableheadlight__HuHZw": `AttendeeCustomTable_CustomTable_tableheadlight__HuHZw__INszt`,
	"CustomTable_tableheaddark__nwqb4": `AttendeeCustomTable_CustomTable_tableheaddark__nwqb4__Ydh-G`,
	"sectionright": `AttendeeCustomTable_sectionright__VsLJr`,
	"exer_modal_contain": `AttendeeCustomTable_exer_modal_contain__OBVAt`,
	"active_show_outer": `AttendeeCustomTable_active_show_outer__8xIOk`,
	"active_show_inner": `AttendeeCustomTable_active_show_inner__0XBsl`,
	"act_box_img": `AttendeeCustomTable_act_box_img__HmdoN`,
	"act_box_cnt": `AttendeeCustomTable_act_box_cnt__CO0Vi`,
	"act_box_bdg": `AttendeeCustomTable_act_box_bdg__RyeZr`,
	"sold": `AttendeeCustomTable_sold__yDKjh`,
	"attent_details": `AttendeeCustomTable_attent_details__UE-T8`,
	"attent_details_inner": `AttendeeCustomTable_attent_details_inner__+5muo`,
	"attent_details_inner_l": `AttendeeCustomTable_attent_details_inner_l__s4ZJ1`,
	"attent_details_inner_r": `AttendeeCustomTable_attent_details_inner_r__VBJS6`,
	"attent_details_row": `AttendeeCustomTable_attent_details_row__MRKC7`,
	"attent_details_row_box": `AttendeeCustomTable_attent_details_row_box__Dcn+4`,
	"attent_details_row_last": `AttendeeCustomTable_attent_details_row_last__2pV44`,
	"interesting_fact": `AttendeeCustomTable_interesting_fact__hV+i6`,
	"showbox_sec": `AttendeeCustomTable_showbox_sec__YPor7`,
	"show_box_main": `AttendeeCustomTable_show_box_main__3PUud`,
	"show_box": `AttendeeCustomTable_show_box__ZKqsy`,
	"no_show_box": `AttendeeCustomTable_no_show_box__gI-I1`,
	"attent_flex": `AttendeeCustomTable_attent_flex__LuDTd`,
	"container": `AttendeeCustomTable_container__xcoZC`,
	"tableheading": `AttendeeCustomTable_tableheading__GyDGF`,
	"search_box": `AttendeeCustomTable_search_box__QlVKg`,
	"spinner": `AttendeeCustomTable_spinner__P97Nm`,
	"tbl_sl": `AttendeeCustomTable_tbl_sl__Sghd-`,
	"tablebtn": `AttendeeCustomTable_tablebtn__GB0Ut`,
	"tableheaddiv": `AttendeeCustomTable_tableheaddiv__teRA8`,
	"sortbtn": `AttendeeCustomTable_sortbtn__47Ecs`,
	"order_date": `AttendeeCustomTable_order_date__mmWt7`,
	"norecord": `AttendeeCustomTable_norecord__AfH9d`,
	"norecordsdiv": `AttendeeCustomTable_norecordsdiv__1+bE+`,
	"ststus_text": `AttendeeCustomTable_ststus_text__gewaA`,
	"ststus_not_verified": `AttendeeCustomTable_ststus_not_verified__9EDWK`,
	"ststus_verified": `AttendeeCustomTable_ststus_verified__Xn1oa`,
	"ststus_cancelled": `AttendeeCustomTable_ststus_cancelled__Ywp6j`,
	"ststus_pending": `AttendeeCustomTable_ststus_pending__Mu9JM`,
	"ststus_waitlisted": `AttendeeCustomTable_ststus_waitlisted__S1OCh`,
	"rowActionsTicketApproval": `AttendeeCustomTable_rowActionsTicketApproval__89Tlh`,
	"approveTicketBtn": `AttendeeCustomTable_approveTicketBtn__KdChC`,
	"rejectTicketBtn": `AttendeeCustomTable_rejectTicketBtn__YvXPu`,
	"ticketApprovalActionSpinner": `AttendeeCustomTable_ticketApprovalActionSpinner__AWYV7`,
	"ticketApprovalSpin": `AttendeeCustomTable_ticketApprovalSpin__fSXnB`,
	"ticketConfirmOverlay": `AttendeeCustomTable_ticketConfirmOverlay__eG9tt`,
	"ticketConfirmCard": `AttendeeCustomTable_ticketConfirmCard__lXYbi`,
	"ticketConfirmIconWrap": `AttendeeCustomTable_ticketConfirmIconWrap__mKjca`,
	"ticketConfirmIconApprove": `AttendeeCustomTable_ticketConfirmIconApprove__PBJ6n`,
	"ticketConfirmIconReject": `AttendeeCustomTable_ticketConfirmIconReject__0onWz`,
	"ticketConfirmTitle": `AttendeeCustomTable_ticketConfirmTitle__rer14`,
	"ticketConfirmBody": `AttendeeCustomTable_ticketConfirmBody__FuF5j`,
	"ticketWaitlistNote": `AttendeeCustomTable_ticketWaitlistNote__MuseL`,
	"ticketConfirmActions": `AttendeeCustomTable_ticketConfirmActions__eihlQ`,
	"ticketConfirmCancelBtn": `AttendeeCustomTable_ticketConfirmCancelBtn__DtSEi`,
	"ticketConfirmApproveBtn": `AttendeeCustomTable_ticketConfirmApproveBtn__dlpI2`,
	"ticketConfirmRejectBtn": `AttendeeCustomTable_ticketConfirmRejectBtn__XLSzn`,
	"refund": `AttendeeCustomTable_refund__-dSx6`,
	"refund_tooltip": `AttendeeCustomTable_refund_tooltip__Bg-mU`,
	"tooltiptext": `AttendeeCustomTable_tooltiptext__r6xdz`,
	"search_contain_box": `AttendeeCustomTable_search_contain_box__OcQ1e`,
	"search_contain_box1": `AttendeeCustomTable_search_contain_box1__DdZQY`,
	"tabbtn": `AttendeeCustomTable_tabbtn__2KYu+`,
	"totalamt": `AttendeeCustomTable_totalamt__LT2p4`,
	"totalamt1": `AttendeeCustomTable_totalamt1__Jpdbh`,
	"eventHeaderRow": `AttendeeCustomTable_eventHeaderRow__RQHSV`,
	"viewEventDetailsBtn": `AttendeeCustomTable_viewEventDetailsBtn__Wi40z`,
	"Total_count": `AttendeeCustomTable_Total_count__KQSZL`,
	"Total_seat_count": `AttendeeCustomTable_Total_seat_count__z-M-N`,
	"user_tb_hd": `AttendeeCustomTable_user_tb_hd__avwA4`,
	"info_contain": `AttendeeCustomTable_info_contain__Me548`,
	"info_content": `AttendeeCustomTable_info_content__HN7om`,
	"dropdown": `AttendeeCustomTable_dropdown__8ExS4`,
	"del_icon": `AttendeeCustomTable_del_icon__oWLMh`,
	"tdactive": `AttendeeCustomTable_tdactive__Q9CO8`,
	"tdinactive": `AttendeeCustomTable_tdinactive__0HIXZ`,
	"tdyellowbg": `AttendeeCustomTable_tdyellowbg__PbpMV`,
	"searchcontainer": `AttendeeCustomTable_searchcontainer__mlndk`,
	"searchcontainer_inner": `AttendeeCustomTable_searchcontainer_inner__-CWtR`,
	"attent_flex_contain": `AttendeeCustomTable_attent_flex_contain__q1YYz`,
	"pay_btn": `AttendeeCustomTable_pay_btn__SUh-t`,
	"count_contain": `AttendeeCustomTable_count_contain__JIQHT`,
	"onboardsty": `AttendeeCustomTable_onboardsty__v6x7b`,
	"search_contain": `AttendeeCustomTable_search_contain__hxCOj`,
	"export_btn": `AttendeeCustomTable_export_btn__05vaH`,
	"dashboardcont2": `AttendeeCustomTable_dashboardcont2__fOe6q`,
	"count_box_contain": `AttendeeCustomTable_count_box_contain__OTD6y`,
	"count_text": `AttendeeCustomTable_count_text__chW1-`,
	"count_num": `AttendeeCustomTable_count_num__IA57o`,
	"table_attendee": `AttendeeCustomTable_table_attendee__qMqyb`
};
export default ___CSS_LOADER_EXPORT___;
